import styled from '@emotion/styled';
import {
  absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost,
  assignTasksToProjectV1ProjectProjectIdAssigningTaskPost,
  assignTasksV1TaskboxesTaskboxIdAssignPost,
  convertTaskToProjectV1ProjectConvertingFromTaskTaskIdPost,
  createCategoryV1CategoryPost,
  createEventV1EventsPost,
  createFrequentWorkV1FrequentworksPost,
  createRecordV1RecordPost,
  createTaskboxV1TaskboxesPost,
  deleteCategoryV1CategoryCategoryIdDelete,
  getAFeatureStorageByNameV1FeatureStorageNameFeatureStorageNameGet,
  getAllRecordV1RecordGet,
  getEventsV1EventsGet,
  mergeWorkOrWorkBoxesV2V2WorksMergePost,
  readAutocompleteListV1AutocompleteGet,
  readFrequentWorksV1FrequentworksGet,
  readTaskboxesV1TaskboxesGet,
  removeEventV1EventsCalendarIdEventIdDelete,
  removeTaskV1WorksWorkIdDelete,
  removeTaskboxV1TaskboxesTaskboxIdDelete,
  updateCategoryV1CategoryCategoryIdPatch,
  updateEventsV1EventsCalendarIdEventIdPut,
  updateFeatureStorageV1FeatureStorageFeatureStorageIdPatch,
  updateMyProfileV1UsersMePatch,
  updateRecurringTaskboxesV1TaskboxesTaskboxIdRecurrencesPatch,
  updateTaskboxV1TaskboxesTaskboxIdPut,
  updateWorkboxesV2V2WorkboxesWorkboxIdPut,
} from 'queries';
import { RefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { COLORS } from 'styles/constants';
import CalendarView, { CustomEvent } from './CalendarView';
import dayjs from 'lib/dayjs';
import { DATE_FORMAT_1, DATE_FORMAT_4 } from 'utils/datetimeFormat';
import {
  CreateTaskbox,
  DateTime,
  InCreateTaskBoxInRecurrenceTarget,
  OutAutoComplete,
  OutSubTask,
  OutTaskboxDetailResponse,
  RemoveTaskboxV1TaskboxesTaskboxIdDeleteParams,
  CreateFrequentWork,
  OutFeatureStorage,
  CreateTaskboxTask,
  CreateFrequentWorkTask,
  OutCategory,
  UpdateTaskForTaskBox,
  OutFrequentWork,
  UpdateTaskBoxRecurrence,
  InRecurrence,
  CreateEventWithParam,
  OutReadEvent,
  UpdateEventWithParam,
  OutRecord,
  InCreateRecord,
  RemoveEventV1EventsCalendarIdEventIdDeleteParams,
} from 'queries/model';
import { useClickOutside, useKeyboardEvent, useUpdateEffect } from '@react-hookz/web';
import { v4 as uuidv4 } from 'uuid';
import toast from 'react-hot-toast';
import { Icons } from 'components';
import { hideScroll } from 'styles/utils';
import { Button, CircularProgress, Dialog, IconButton, MenuItem, MenuList, Modal, Popover, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TimelineView } from '../components/TimelineView';
import { useAtom } from 'jotai';
import { dragContextAtom } from 'atoms/works';
import { nowAtom } from 'atoms/now';
import { tasksAtom } from 'atoms/tasks';
import TaskSelectionView, { TaskSelectionViewTask } from '../components/TaskSelectionView';
import { useInView, InView } from 'react-intersection-observer';
import { debounce, groupBy, omit, pick, update } from 'lodash';
import { Tutorial } from 'components/Tutorial';
import { userAtom } from 'atoms/user';
import { UpdateRecurrenceDialog } from 'components/Recurrence/UpdateRecurrenceDialog';
import { createPortal } from 'react-dom';
import { TimerActionType } from '..';
import { foldCalendarViewAtom, foldSidePanelViewAtom, taskViewAtom } from 'atoms/foldView';
import { osName } from 'react-device-detect';
import InboxContextMenu, { InboxContextMenuType } from 'components/InboxContextMenu';
import { RemoveRecurrenceDialog } from 'components/Recurrence/RemoveRecurrenceDialog';
import { highlightNotificationAtom, ritualAlarmAtom, ritualEntryAtom, shutdownHighlightNotificationAtom } from 'atoms/notification';
import { GAEventTrigger } from 'lib/gtag';
import HighlightInfoDialog from '../components/HighlightInfoDialog';
import { CalendarEventsFilter } from '../Month';
import { getBrowserName } from 'utils/browser';
import { categoryAtom } from 'atoms/category';
import { userSettingAtom } from 'atoms/userSetting';
import {
  changedProjectIdAtom,
  fetchInstancesFromProjectDetailViewAtom,
  moveToInstanceAtom,
  projectsAtom,
  selectedProjectAtom,
  syncInstanceAtom,
} from 'atoms/projects';
import { startNowPopupVisibleAtom } from 'atoms/popup';
import { CategoryActionType } from '../components/CategoryPopover';
import EventCreationPopover from 'pages/Meeting/components/EventCreationPopover';
import { ReflectionTemplate } from 'components/ReflectionTemplate/ReflectionTemplate';
import { ReflectionCalendarReadOnly } from 'components/ReflectionCalendarReadOnly/ReflectionCalendarReadOnly';
import { userStateAtom } from 'atoms/userState';
import { DF } from 'constants/dateFormat';
import { ritualAlarmTimeAtom } from 'atoms/timer';
import { syncTaskboxDetailViewAtom, taskboxDetailViewAtom } from 'atoms/taskboxDetail';
import { fetchRoutineFromDetailViewAtom, selectedRoutineAtom, selectedRoutineDateAtom } from 'atoms/routine';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

const TaskViewWrapper = styled.div<{ foldCalendar?: boolean; foldSidePanel?: boolean }>`
  width: 100%;
  height: 100%;
  min-width: 702px;
  display: flex;
  padding: 0px 0px;
  justify-content: center;
  background-color: ${COLORS.gray200};
  overflow-y: auto;
  overflow-anchor: auto;
  ${hideScroll()};
`;

const TaskViewFixedCenter = styled.div`
  width: 630px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TaskBoardWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const TaskBoardTopButtonWrapper = styled.div`
  margin-top: 12px;
  height: 40px;
  text-align: center;
  overflow-anchor: none;
`;
const TaskBoardBottomButtonWrapper = styled.div`
  margin-top: 36px;
  height: 60px;
  text-align: center;
`;

const TaskBoardButtonTextWrapper = styled.span`
  margin-right: 8px;
  color: ${COLORS.gray600};
  font-weight: bold;
  font-size: 13px;
`;

const TaskBoardContainer = styled.div<{ focused?: boolean }>`
  margin-bottom: 36px;
  border-radius: 8px;
  box-shadow: ${(props) => (props.focused ? `0px 8px 16px ${COLORS.shadow100}` : 'none')};
`;

const KeyboardButtonRect = styled.span<{ small?: boolean }>`
  height: 16px;
  background: #ffffff;
  border: 1px solid ${COLORS.gray400};
  border-radius: 2px;
  font-size: 10px;
  font-weight: 700;
  color: ${COLORS.gray500};
  padding: ${(props) => `${props.small ? '1px 3px' : '4px'}`};
`;

const KeyboardCommandPlus = styled.span`
  font-size: 12px;
  color: ${COLORS.white};
  margin: 0px 4px;
`;

const FocusTaskboxBanner = styled.div`
  width: 162px;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.white};
  bottom: 30px;
  box-shadow: 0px 8px 16px rgba(26, 30, 39, 0.16);
  padding: 8px 16px;
  border-radius: 8px;
  z-index: 10;
  cursor: pointer;
  overflow: hidden;
`;

const FocusTaskboxInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const RitualNotification = styled.div`
  width: 225px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 80px;
  right: -54px;
  z-index: 101;
  background-color: ${COLORS.white};
  border-radius: 8px;
  box-shadow: 0px 10.566px 21.132px 0px rgba(26, 30, 39, 0.16);
  padding: 12px;

  ::before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 10px 12px 0px 12px;
    border-color: ${COLORS.white} transparent;
    display: block;
    width: 0;
    z-index: 100;
    bottom: -8px;
    left: 50%;
    @media screen and (max-width: 650px) {
      left: 8px;
    }
  }
`;

const SnoozeWrapper = styled.div`
  padding: 8px 0px;

  .MuiList-root {
    padding: 0px 8px;
  }

  .MuiMenuItem-root {
    border-radius: 6px;
    font-size: 12px;
    padding: 5px 8px;
    :hover {
      background-color: ${COLORS.gray100};
    }
  }
`;

const TutorialWrapper = styled.div`
  .MuiPaper-root {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
`;

const TutorialArrowContainer = styled.div`
  width: 100%;
  height: 12px;
  background-color: transparent;
`;

const CompleteCreateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
`;

const CompleteCreateTitle = styled.div`
  margin-top: 32px;
  font-size: 24px;
  font-weight: 700;
  color: ${COLORS.gray900};
`;

const CompleteCreateSubTitle = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  font-size: 16px;
  font-weight: 400;
  color: ${COLORS.gray900};
`;

const CompleteCreateNotice = styled.div`
  margin-top: 24px;
  font-size: 13px;
  font-weight: 400;
  color: ${COLORS.gray900};
`;

export interface TaskBoardProps {
  id: string;
  date: Date;
  taskboxes?: OutTaskboxDetailResponse[];
  entireBoardTaskboxes?: OutTaskboxDetailResponse[];
  editing?: boolean;
  expanded?: boolean;
  parentRef?: RefObject<HTMLDivElement>;
  selectedEventId?: string;
  selectedSubtaskId?: string;
  focused?: boolean;
  incompleteTaskboxList?: OutAutoComplete[];
  templateList?: OutFrequentWork[];
  multiSelectIds?: string[];
  multiSelectAnchorEl?: HTMLElement | null;
  categoryList?: OutCategory[];
  multiSelectSubtaskIds?: MultiSelectSubtaskIds[];
  multiSelectSubtaskAnchorEl?: HTMLElement | null;
  onCreateTaskbox?: (date: Date, taskbox: CreateTaskbox) => void;
  onClickEditTaskBoard?: (date: Date) => void;
  onClickExpand?: (date: Date) => void;
  onChange?: (startDate: Date, endDate?: Date, move?: boolean) => void;
  onClickTaskbox?: (date: Date, id: string) => void;
  onClickSubtask?: (id: string) => void;
  onClickTaskBoard?: (id: string, date: Date) => void;
  onFocused?: (id: string) => void;
  onDropTask?: (date: Date) => void;
  onFetchIncompleteTaskboxes?: (title?: string) => void;
  onFetchTemplateList?: () => void;
  onChangeMultiSelectIds?: (id: string, e?: React.MouseEvent<HTMLDivElement>) => void;
  onChangeMultiSelectList?: (ids: string[]) => void;
  onCloseMultiSelect?: () => void;
  onMultiSelectAnchorElNull?: () => void;
  onChangeTimer?: (type: TimerActionType, time?: Date) => void;
  onBeautifulDndDrop?: (date: Date, taskboxes: OutTaskboxDetailResponse[]) => void;
  onFetchCategoryList?: () => void;
  onUpdateTaskboardFromListView?: (date: string, taskboxes: OutTaskboxDetailResponse[]) => void;
  onContextMenuTaskbox?: (id: string) => void;
  onChangeMultiSelectSubtaskIds?: (subtaskList: MultiSelectSubtaskIds[], e?: React.MouseEvent<HTMLDivElement>) => void;
  onClickMultiSelectSubtaskAction?: (type: InboxContextMenuType, data: any) => void;
  onCloseMultiSelectSubtask?: () => void;
  onMultiSelectSubtaskAnchorElNull?: () => void;
}

export type CustomCreateMeetingEvent = CustomEvent & CreateEventWithParam;

const TaskBoard = (props: TaskBoardProps) => {
  const {
    id,
    date,
    taskboxes = [],
    entireBoardTaskboxes = [],
    expanded,
    editing,
    parentRef,
    selectedEventId,
    selectedSubtaskId,
    focused,
    incompleteTaskboxList = [],
    templateList = [],
    multiSelectIds = [],
    multiSelectAnchorEl,
    categoryList = [],
    multiSelectSubtaskIds = [],
    multiSelectSubtaskAnchorEl,
    onCreateTaskbox,
    onClickEditTaskBoard,
    onClickExpand,
    onChange,
    onClickTaskbox,
    onClickSubtask,
    onClickTaskBoard,
    onFocused,
    onDropTask,
    onFetchIncompleteTaskboxes,
    onFetchTemplateList,
    onChangeMultiSelectIds,
    onChangeMultiSelectList,
    onCloseMultiSelect,
    onMultiSelectAnchorElNull,
    onChangeTimer,
    onBeautifulDndDrop,
    onFetchCategoryList,
    onUpdateTaskboardFromListView,
    onContextMenuTaskbox,
    onChangeMultiSelectSubtaskIds,
    onClickMultiSelectSubtaskAction,
    onCloseMultiSelectSubtask,
    onMultiSelectSubtaskAnchorElNull,
  } = props;
  const [isHeaderInViewport, setIsHeaderInViewport] = useState(false);

  const handleChangeInView = (inView: boolean) => {
    setIsHeaderInViewport(inView);
  };

  const handleCreateTaskbox = (taskbox: CreateTaskbox) => {
    onCreateTaskbox?.(date, taskbox);
  };

  const handleChange = (date: Date, endDate?: Date, move?: boolean) => {
    onChange?.(date, endDate, move);
  };

  const handleClickExpand = (date: Date) => {
    onClickExpand?.(date);
  };

  const handleClickTimelineTaskbox = (taskbox: OutTaskboxDetailResponse) => {
    onClickTaskbox?.(date, taskbox.id!);
  };

  const handleClickFocusInput = () => {
    const taskView = document.getElementById('task-view');
    const taskBoard = document.querySelector(`[data-board-id="${id}"]`) as HTMLDivElement;
    taskView?.scrollTo({ top: taskBoard?.offsetTop - 12 });
  };

  const handleFocus = () => {
    onFocused?.(id);
  };

  const handleMultiSelect = (id: string, e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    onChangeMultiSelectIds?.(id, e);
  };

  const handleMultiSelectList = (ids: string[]) => {
    onChangeMultiSelectList?.(ids);
  };

  const handleClickTaskBoard = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    onClickTaskBoard?.(id, date);
  };

  const handleClickSubtask = (id: string) => {
    onClickSubtask?.(id);
  };

  return (
    <InView as="div" rootMargin="0% 0px -95% 0px" initialInView={true} onChange={handleChangeInView}>
      <TaskBoardContainer data-board-id={id} onFocus={handleFocus} focused={focused} onClick={(e) => handleClickTaskBoard(e)}>
        <TimelineView
          ref={parentRef}
          date={date}
          expanded={expanded}
          // events={
          //   taskboxes.filter((v) =>
          //     v.start?.datetime ? dayjs(v.start?.datetime).isSame(dayjs(date), 'date') : dayjs(v.start?.date).isSame(dayjs(date), 'date'),
          //   ) as any
          // }
          events={taskboxes.filter((v) => v.matchDate?.includes(dayjs(date).format(DATE_FORMAT_4)))}
          entireBoardTaskboxes={entireBoardTaskboxes}
          isHeaderInViewport={isHeaderInViewport}
          focusedTaskBoard={focused}
          editing={editing}
          selectedEvent={taskboxes.find((v) => v.id === selectedEventId) as any}
          selectedSubtaskId={selectedSubtaskId}
          onClickTaskbox={handleClickTimelineTaskbox}
          onClickSubtask={handleClickSubtask}
          incompleteTaskboxList={incompleteTaskboxList}
          templateList={templateList}
          multiSelectIds={multiSelectIds}
          multiSelectAnchorEl={multiSelectAnchorEl}
          categoryList={categoryList}
          multiSelectSubtaskIds={multiSelectSubtaskIds}
          multiSelectSubtaskAnchorEl={multiSelectSubtaskAnchorEl}
          onChange={handleChange}
          onCreateTaskbox={handleCreateTaskbox}
          onDropTask={onDropTask}
          onClickExpand={handleClickExpand}
          onClickFocusInput={handleClickFocusInput}
          onClickEditTaskBoard={onClickEditTaskBoard}
          onFetchIncompleteTaskboxes={onFetchIncompleteTaskboxes}
          onFetchTemplateList={onFetchTemplateList}
          onChangeMultiSelectIds={handleMultiSelect}
          onChangeMultiSelectList={handleMultiSelectList}
          onCloseMultiSelect={onCloseMultiSelect}
          onMultiSelectAnchorElNull={onMultiSelectAnchorElNull}
          onChangeTimer={onChangeTimer}
          onBeautifulDndDrop={onBeautifulDndDrop}
          onFetchCategoryList={onFetchCategoryList}
          onUpdateTaskboardFromListView={onUpdateTaskboardFromListView}
          onContextMenuTaskbox={onContextMenuTaskbox}
          onChangeMultiSelectSubtaskIds={onChangeMultiSelectSubtaskIds}
          onClickMultiSelectSubtaskAction={onClickMultiSelectSubtaskAction}
          onCloseMultiSelectSubtask={onCloseMultiSelectSubtask}
          onMultiSelectSubtaskAnchorElNull={onMultiSelectSubtaskAnchorElNull}
        />
      </TaskBoardContainer>
    </InView>
  );
};

interface TaskTodayProps {
  onChangeTimer?: (type: TimerActionType, time?: Date) => void;
}

export type MultiSelectSubtaskIds = {
  taskboxId: string;
  subtaskIds: string[];
};

export const TaskToday = ({ onChangeTimer }: TaskTodayProps) => {
  const navigate = useNavigate();
  const [meetings, setMeetings] = useState<OutReadEvent[]>([]);
  const [taskBoards, setTaskBoards] = useState<{ id: string; date: Date; taskboxes: OutTaskboxDetailResponse[] }[]>([]);
  const [taskboxes, setTaskboxes] = useState<OutTaskboxDetailResponse[]>([]);
  const [selectedEventId, setSelectedEventId] = useState<string | undefined>();
  const [selectedSubtaskId, setSelectedSubtaskId] = useState<string | undefined>();
  const [newTaskbox, setNewTaskbox] = useState<CreateTaskbox & { allDay: boolean }>();
  const [newMeeting, setNewMeeting] = useState<CreateEventWithParam & { allDay: boolean; id: string; isInvited?: boolean }>();
  const refTaskView = useRef<HTMLDivElement>(null);
  const refCalendarView = useRef<HTMLDivElement>(null);
  const [taskViewDragContext] = useAtom(dragContextAtom);
  const [currentDate, setCurrentDate] = useAtom(nowAtom);
  const [currentTaskBoardDate, setCurrentTaskBoardDate] = useState<Date>(new Date());
  const [taskSelectionModal, setTaskSelectionModal] =
    useState<{ open: boolean; id?: string; issueTitle?: string; start?: DateTime; end?: DateTime; tasks?: OutSubTask[] } | null>();
  const [isLoading, setLoading] = useState(false);
  const [suppressScrollEvent, setSuppressScrollEvent] = useState(false);
  const [boardWritingStatus, setBoardWritingStatus] = useState<Map<string, boolean>>(new Map());
  const [boardExpandStatus, setBoardExpandStatus] = useState<Map<string, boolean>>(new Map());
  const { ref: refInBottomView, inView: inBottomView } = useInView({ initialInView: true, delay: 100, trackVisibility: true, threshold: 0.1 });
  const [incompleteTaskboxList, setIncompleteTaskbox] = useState<OutAutoComplete[]>([]);
  const [templateList, setTemplateList] = useState<OutFrequentWork[]>([]);
  const [tutorialAnchorEl, setTutorialAnchorEl] = useState<null | HTMLElement>(null);
  const [tutorialReplay, setTutorialReplay] = useState(false);
  const [tutorialStatus, setTutorialStatus] = useState<boolean | null>(null);
  const [todoTasks, updateTodoTasks] = useAtom(tasksAtom);
  const [user] = useAtom(userAtom);
  const [updateRecurringTaskboxParams, setUpdateRecurringTaskboxParams] =
    useState<{ eventId: string; recurrence: InRecurrence; start: DateTime | null; end: DateTime | null } | null>(null);
  const [updateRecurringEventParams, setUpdateRecurringEventParams] = useState<OutReadEvent | null>(null);
  const [calendarEventEditing, setCalendarEventEditing] = useState(false);
  const [multiSelectTaskboxIds, setMultiSelectTaskboxIds] = useState<string[]>([]);
  const [multiSelectAnchorEl, setMultiSelectAnchorEl] = useState<HTMLElement | null>(null);
  const [foldCalendar, setFoldCalendar] = useAtom(foldCalendarViewAtom);
  const [foldSidePanel] = useAtom(foldSidePanelViewAtom);
  const [, setIsHoverWidthLine] = useState(false);
  const [taskboxDetailAnchorEl, setTaskboxDetailAnchorEl] = useState<HTMLElement | null>(null);
  const [contextTaskbox, setContextTaskbox] = useState<OutTaskboxDetailResponse>();
  const [removeRecurringTaskboxPopup, setRemoveRecurringTaskboxPopup] = useState(false);
  const [removeRecurringEventPopup, setRemoveRecurringEventPopup] = useState(false);
  const [ritualAlarm, setRitualAlarm] = useAtom(ritualAlarmAtom);
  const [, setRitualEntry] = useAtom(ritualEntryAtom);
  const [, setTaskView] = useAtom(taskViewAtom);
  const [openHighlightInfo, setOpenHighlightInfo] = useState(false);
  const [shutdownHighlightNotification, setShutdownHighlightNotification] = useAtom(shutdownHighlightNotificationAtom);
  const [highlightNotification, setHighlightNotification] = useAtom(highlightNotificationAtom);
  const [isFirstLoading, setIsFirstLoading] = useState(false);
  const [ritualSettingEl, setRitualSettingEl] = useState<HTMLElement | null>(null);
  const [snoozeAnchorEl, setSnoozeAnchorEl] = useState<HTMLElement | null>(null);
  const [snoozeTime] = useState(JSON.parse(localStorage.getItem('snooze-time') || '[]'));
  const [calendarFilter, setCalendarFilter] = useState<CalendarEventsFilter>((localStorage.getItem('calendarFilter') as CalendarEventsFilter) || 'ALL');
  const [userSetting] = useAtom(userSettingAtom);
  const [userState] = useAtom(userStateAtom);
  const [categoryList, fetchCategoryList] = useAtom(categoryAtom);
  const [projects, fetchProjects] = useAtom(projectsAtom);
  const [fetchInstancesFromProjectDetailView, setFetchInstancesFromProjectDetailView] = useAtom(fetchInstancesFromProjectDetailViewAtom);
  const [, setChangedProjectId] = useAtom(changedProjectIdAtom);
  const [isStartAfter, setIsStartAfter] = useState(false);
  const [startNowPopupVisible, fetchStartNowPopupVisible] = useAtom(startNowPopupVisibleAtom);
  const [selectedProject, setSelectedProject] = useAtom(selectedProjectAtom);
  const [moveToInstance, setMoveToInstance] = useAtom(moveToInstanceAtom);
  const [, setRitualAlarmTime] = useAtom(ritualAlarmTimeAtom);
  const [isReflectionDialogOpen, setIsReflectionDialogOpen] = useState<boolean>(localStorage.getItem('reflection-dialog') === 'true');
  const [isCompleteCreateDialogOpen, setIsCompleteCreateDialogOpen] = useState(false);
  const [records, setRecords] = useState<OutRecord[]>([]);
  const [countDown, setCountDown] = useState(0);
  const [syncInstance] = useAtom(syncInstanceAtom);
  const [taskboxDetailView, setTaskboxDetailView] = useAtom(taskboxDetailViewAtom);
  const [syncTaskboxDetailView, setSyncTaskboxDetailView] = useAtom(syncTaskboxDetailViewAtom);
  const [multiSelectSubtaskIds, setMultiSelectSubtaskIds] = useState<MultiSelectSubtaskIds[]>([]);
  const [multiSelectSubtaskAnchorEl, setMultiSelectSubtaskAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedRoutine, setSelectedRoutine] = useAtom(selectedRoutineAtom);
  const [fetchRoutineFromDetailView, setFetchRoutineFromDetailView] = useAtom(fetchRoutineFromDetailViewAtom);
  const [, setSelectedRoutineDate] = useAtom(selectedRoutineDateAtom);

  useEffect(() => {
    if (!moveToInstance) return;
    handleChangeCurrentDate(dayjs(moveToInstance.start?.date || moveToInstance.start?.datetime).toDate());
  }, [moveToInstance]);

  useEffect(() => {
    init();
    fetchIncompleteTaskboxes();
    fetchTemplateList();
    fetchCategoryList();
    localStorage.setItem('task-view', 'today');
    setTaskView('today');
    localStorage.getItem('task-board-expand-status') && setBoardExpandStatus(new Map(JSON.parse(localStorage.getItem('task-board-expand-status')!)));
  }, []);

  useEffect(() => {
    if (isLoading) return;
    const status = user?.tutorialStatus;
    setTutorialStatus(status!);

    //튜토리얼 정책 및 개선 완료할 때까지 주석처리
    // if (!status && !isLoading && taskboxes.length > 0) {
    //   const turorial = document.getElementById('tutorial-replay');
    //   if (turorial) setTimeout(() => setTutorialAnchorEl(turorial), 1000);
    // }
  }, [isLoading]);

  useEffect(() => {
    handleHighlightNotification();
  }, [currentTaskBoardDate, taskboxes, shutdownHighlightNotification]);

  useEffect(() => {
    if (contextTaskbox) {
      const currentTaskboxes = taskboxes.filter((taskbox) => taskbox.matchDate?.includes(dayjs(currentDate).format(DATE_FORMAT_4)) && !taskbox.allDay);
      const index = currentTaskboxes.findIndex((item) => item.id === contextTaskbox.id);
      setIsStartAfter(currentTaskboxes[index - 1] ? true : false);
    } else {
      setIsStartAfter(false);
    }
  }, [contextTaskbox]);

  useEffect(() => {
    if (!selectedRoutine) setSelectedRoutineDate(dayjs().toDate());
  }, [selectedRoutine]);

  useClickOutside(
    refCalendarView,
    (e) => {
      let currentElement = e.target as HTMLElement;
      const classListCheck = (element: HTMLElement, classNames: string[]) => classNames.some((className) => element.classList.contains(className));
      const isInside = {
        taskbox: false,
        projectCategory: false,
        projectDeadline: false,
        projectInprogress: false,
        projectStatus: false,
        projectLink: false,
        projectDetailView: false,
        projectDetailMenu: false,
        projectDelete: false,
        taskboxDetailLink: false,
        taskboxDetailCategory: false,
        taskboxDetailDeadline: false,
        taskboxDetailDelete: false,
        taskboxDetailComplete: false,
        taskboxDetailContinue: false,
        taskboxDetailView: false,
        routineCategory: false,
        routineLink: false,
        sidePanelResizable: false,
        memoFloatingToolbar: false,
        subtaskMultiSelect: false,
        ConfirmDialog: false,
        timeSelect: false,
        autoComplete: false,
        MuiAutocompletePopper: false,
        MuiPaperRoot: false,
      };

      while (currentElement) {
        if (currentElement.classList) {
          if (classListCheck(currentElement, ['timeline-container'])) isInside.taskbox = true;
          if (classListCheck(currentElement, ['project-category'])) isInside.projectCategory = true;
          if (classListCheck(currentElement, ['project-deadline'])) isInside.projectDeadline = true;
          if (classListCheck(currentElement, ['project-inprogress'])) isInside.projectInprogress = true;
          if (classListCheck(currentElement, ['project-status'])) isInside.projectStatus = true;
          if (classListCheck(currentElement, ['project-link', 'MuiBackdrop-root'])) isInside.projectLink = true;
          if (classListCheck(currentElement, ['project-detail'])) isInside.projectDetailView = true;
          if (classListCheck(currentElement, ['project-detail-menu'])) isInside.projectDetailMenu = true;
          if (classListCheck(currentElement, ['project-delete'])) isInside.projectDelete = true;
          if (classListCheck(currentElement, ['taskbox-detail-link', 'MuiBackdrop-root'])) isInside.taskboxDetailLink = true;
          if (classListCheck(currentElement, ['taskbox-detail-category'])) isInside.taskboxDetailCategory = true;
          if (classListCheck(currentElement, ['taskbox-detail-deadline'])) isInside.taskboxDetailDeadline = true;
          if (classListCheck(currentElement, ['taskbox-detail-delete'])) isInside.taskboxDetailDelete = true;
          if (classListCheck(currentElement, ['taskbox-detail-complete'])) isInside.taskboxDetailComplete = true;
          if (classListCheck(currentElement, ['taskbox-detail-continue'])) isInside.taskboxDetailContinue = true;
          if (classListCheck(currentElement, ['taskbox-detail-view'])) isInside.taskboxDetailView = true;
          if (classListCheck(currentElement, ['routine-category'])) isInside.routineCategory = true;
          if (classListCheck(currentElement, ['routine-link', 'MuiBackdrop-root'])) isInside.projectLink = true;
          if (classListCheck(currentElement, ['side-panel-resizable'])) isInside.sidePanelResizable = true;
          if (classListCheck(currentElement, ['memo-floating-toolbar'])) isInside.memoFloatingToolbar = true;
          if (classListCheck(currentElement, ['subtask-multi-select'])) isInside.subtaskMultiSelect = true;
          if (classListCheck(currentElement, ['MuiDialog-container'])) isInside.ConfirmDialog = true;
          if (classListCheck(currentElement, ['time-select'])) isInside.timeSelect = true;
          if (classListCheck(currentElement, ['auto-complete'])) isInside.autoComplete = true;
          if (classListCheck(currentElement, ['MuiAutocomplete-popper'])) isInside.MuiAutocompletePopper = true;
          if (classListCheck(currentElement, ['MuiPaper-root'])) isInside.MuiPaperRoot = true;

          if (Object.values(isInside).some(Boolean)) break;
        }
        currentElement = currentElement.parentElement!;
      }

      const isOutsideAll = !Object.values(isInside).some(Boolean);

      if (!calendarEventEditing && isOutsideAll) {
        if (selectedEventId) setSelectedEventId(undefined);
        if (selectedProject) setSelectedProject(null);
        if (selectedRoutine) setSelectedRoutine(null);
        if (taskboxDetailView) setTaskboxDetailView(null);
      }
      if (isOutsideAll && selectedProject) setSelectedProject(null);
      if (isOutsideAll && selectedRoutine) setSelectedRoutine(null);
      if (newTaskbox && !calendarEventEditing) setNewTaskbox(undefined);
      if (newMeeting && !calendarEventEditing && !meetingAnchorEl) setNewMeeting(undefined);
    },
    ['mouseup'],
  );

  useKeyboardEvent(
    true,
    (ev) => {
      const element = document.activeElement;

      if (ev.shiftKey && ev.code === 'KeyT' && !ev.altKey) {
        if (!element) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }
        handleChangeCurrentDate(new Date());
      }

      // 주간 뷰로 이동
      if (ev.code === 'KeyW') {
        if (!element) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }
        navigate('/task/week');
      }

      //월간뷰로 이동
      if (ev.code === 'KeyM') {
        if (!element) return;
        const popover = document.querySelector('.MuiPopover-paper') as HTMLElement;
        if (popover) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }
        navigate('/task/month');
      }

      // 전날 일지로 이동
      if (ev.code === 'ArrowLeft') {
        if (!element) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }
        handleChangeCurrentDate(dayjs(currentDate).subtract(1, 'day').toDate());
      }

      // 다음날 일지로 이동
      if (ev.code === 'ArrowRight') {
        if (!element) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }
        handleChangeCurrentDate(dayjs(currentDate).add(1, 'day').toDate());
      }

      if (ev.code === 'ArrowUp' || ev.code === 'ArrowDown') {
        if (selectedEventId || multiSelectTaskboxIds.length > 0) ev.preventDefault();
      }

      if (ev.key === 'Escape') {
        if (newTaskbox) {
          setCalendarEventEditing(false);
          setNewTaskbox(undefined);
        }
        if (newMeeting) {
          setCalendarEventEditing(false);
          setNewMeeting(undefined);
        }
        if (multiSelectTaskboxIds.length > 0) handleCloseMultiSelect();
        if (multiSelectSubtaskIds.length > 0) handleCloseMultiSelectSubtask();
        if (selectedEventId) {
          if (!element) return;
          (element as HTMLElement).blur();
          if (
            element.tagName === 'TEXTAREA' ||
            (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
            (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
          ) {
            return;
          }
          if (selectedSubtaskId) setSelectedSubtaskId(undefined);
          else setSelectedEventId(undefined);
        }
      }

      if ((ev.metaKey || ev.ctrlKey) && ev.altKey && ev.code == 'BracketLeft') {
        if (!element) return;

        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }

        handleClickFoldCalendarView();
      }

      if (ev.altKey && ev.code === 'KeyF') {
        ev.preventDefault();
        if (!element) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }

        handleClickExpand(currentDate);
      }

      if (ev.code.startsWith('Digit') && !ev.altKey && !ev.ctrlKey && !ev.metaKey && !ev.shiftKey) {
        if (!element) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }
        const index = ev.code.replace('Digit', '');
        const taskboxes = taskBoards
          .find((item) => dayjs(item.date).isSame(currentDate))
          ?.taskboxes.filter((item) => dayjs(item.start?.datetime || item.start?.date).isSame(currentDate, 'day'));

        if (taskboxes && taskboxes.length > 0 && taskboxes[Number(index) - 1]) handleClickTaskbox(currentDate, taskboxes[Number(index) - 1].id!);
      }

      if ((ev.metaKey || ev.ctrlKey) && !ev.altKey && !ev.shiftKey) {
        if (!element) return;
        if (
          element.tagName === 'TEXTAREA' ||
          (element.tagName === 'INPUT' && (element as HTMLInputElement).type === 'text') ||
          (element.tagName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true')
        ) {
          return;
        }
        setIsOptionPressed(true);
      }
    },
    [],
    { event: 'keydown', eventOptions: { passive: false } },
  );

  useEffect(() => {
    const newBoardExpandStatus = new Map(taskBoards.map((item) => [item.id, userState.data.isShowingSubtask!]));
    setBoardExpandStatus(newBoardExpandStatus);
    localStorage.setItem('task-board-expand-status', JSON.stringify([...newBoardExpandStatus]));
  }, [userState.data.isShowingSubtask]);

  useUpdateEffect(() => {
    const fetch = async () => {
      const taskBoard = await fetchTaskBoard(dayjs(currentDate).subtract(1, 'day').toDate(), dayjs(currentDate).add(7, 'day').toDate());
      setTaskBoards(taskBoard);
    };
    fetch();
  }, [userState.data.taskViewMode]);

  useUpdateEffect(() => {
    if (inBottomView && !isLoading && !suppressScrollEvent) {
      (async () => {
        const date = taskBoards?.length > 0 ? taskBoards[taskBoards.length - 1].date : currentDate;
        const from = dayjs(date).add(1, 'day').toDate();
        const to = dayjs(date).add(8, 'day').toDate();

        setLoading(true);
        const nextTaskBoards = await fetchTaskBoard(from, to);
        setTaskBoards([...taskBoards, ...nextTaskBoards]);
        setLoading(false);
      })();
    }
  }, [inBottomView]);

  useUpdateEffect(() => {
    if (taskBoards.length) updateTaskboxes(currentDate);
  }, [JSON.stringify(todoTasks)]);

  useUpdateEffect(() => {
    if (!syncTaskboxDetailView) return;
    if (syncTaskboxDetailView.syncType === 'detail') {
      const { syncType, ...others } = syncTaskboxDetailView;
      setTaskBoards((prev) =>
        prev.map((board) => {
          const updatedTaskboxes = board.taskboxes.map((taskbox) => (taskbox.id === syncTaskboxDetailView.id ? { ...others } : taskbox));
          return board.taskboxes.some((taskbox) => taskbox.id === syncTaskboxDetailView.id) ? { ...board, taskboxes: updatedTaskboxes } : board;
        }),
      );
    }

    // handleChangeTaskBoard(currentDate);
  }, [syncTaskboxDetailView]);

  useUpdateEffect(() => {
    if (!fetchInstancesFromProjectDetailView) return;
    setChangedProjectId(null);
    setFetchInstancesFromProjectDetailView(false);

    const updateTaskBoards = async () => {
      const from = taskBoards[0]?.date;
      const to = taskBoards[taskBoards.length - 1]?.date;
      if (from && to) {
        const updatedTaskBoards = await fetchTaskBoard(from, to);
        setTaskBoards(updatedTaskBoards);
      }
    };

    updateTaskBoards();
  }, [fetchInstancesFromProjectDetailView]);

  useUpdateEffect(() => {
    if (!fetchRoutineFromDetailView) return;
    setFetchRoutineFromDetailView(false);

    const updateTaskBoards = async () => {
      const from = taskBoards[0]?.date;
      const to = taskBoards[taskBoards.length - 1]?.date;
      if (from && to) {
        const updatedTaskBoards = await fetchTaskBoard(from, to);
        setTaskBoards(updatedTaskBoards);
      }
    };

    updateTaskBoards();
  }, [fetchRoutineFromDetailView]);

  const refresh = async (date: Date, refresh?: boolean) => {
    const meetings = await fetchMeetings(date, refresh);
    const taskboxes = await fetchTaskboxes(date);
    const taskBoard = await fetchTaskBoard(dayjs(date).subtract(1, 'day').toDate(), dayjs(date).add(7, 'day').toDate());

    setMeetings(meetings);
    setTaskboxes(taskboxes);
    setTaskBoards(taskBoard);
    setBoardWritingStatus(
      new Map(taskBoard.filter((item) => item.taskboxes.length || dayjs(item.date).isToday() || dayjs(item.date).isTomorrow()).map((item) => [item.id, true])),
    );
    setCurrentDate(date);
    setCurrentTaskBoardDate(date);
  };

  const updateTodayView = useCallback(async (date: Date) => {
    const [meetings, taskboxes] = await Promise.all([fetchMeetings(date), fetchTaskboxes(date)]);
    setMeetings(meetings);
    setTaskboxes(taskboxes);
    setTaskBoards((state) => state.map((item) => (item.id === dayjs(date).format(DATE_FORMAT_4) ? { ...item, taskboxes: taskboxes } : item)));
  }, []);

  const debounceFetch = useMemo(() => debounce(updateTodayView, 300), [updateTodayView]);

  const calendarEvents = useMemo(() => {
    const meetingEvents: CustomEvent[] = meetings.map((item: OutReadEvent) => ({
      id: item.id || '',
      title: item.summary || '',
      start: item.allDay ? dayjs(item.start?.date).toDate() : dayjs(item.start?.datetime, { utc: true }).toDate(),
      end: item.allDay ? dayjs(item.end?.date).toDate() : dayjs(item.end?.datetime, { utc: true }).toDate(),
      data: item,
      type: 'meeting',
      allDay: item.allDay,
      calendarColor: item.calendarColor,
      category: item.category,
    }));

    const taskboxEvents: CustomEvent[] = taskboxes.map((item: OutTaskboxDetailResponse) => ({
      id: item.id || '',
      title: item.title || '',
      start: item.allDay ? dayjs(item.start?.date).toDate() : dayjs(item.start?.datetime, { utc: true }).toDate(),
      end: item.allDay ? dayjs(item.end?.date).toDate() : dayjs(item.end?.datetime, { utc: true }).toDate(),
      data: item.tasks,
      type: 'task',
      done: item.done,
      allDay: item.allDay,
      focus: item.focus,
      lockedIn: item.lockedIn,
      isRecurrence: item.isRecurrence || !!item.routine,
      isProject: !!item.project,
      category: item.category,
      durationMin: item.durationMin,
    }));

    const newTaskboxEvent: CustomEvent[] =
      newTaskbox && newTaskbox.id
        ? [
            {
              id: newTaskbox.id,
              title: newTaskbox.title || '',
              start: newTaskbox.start?.date ? dayjs(newTaskbox.start?.date).toDate() : dayjs(newTaskbox.start?.datetime, { utc: true }).toDate(),
              end: newTaskbox.end?.date ? dayjs(newTaskbox.end?.date).toDate() : dayjs(newTaskbox.end?.datetime, { utc: true }).toDate(),
              type: 'task',
              allDay: Boolean(newTaskbox.allDay),
              category: newTaskbox.categoryId && newTaskbox.categoryId.length > 0 ? categoryList.find((v) => v.id === newTaskbox.categoryId![0]) : null,
            },
          ]
        : [];

    const newMeetingEvent: CustomCreateMeetingEvent[] = newMeeting
      ? [
          {
            id: newMeeting.id,
            title: newMeeting.summary || '',
            start: newMeeting.start?.date ? dayjs(newMeeting.start?.date).toDate() : dayjs(newMeeting.start?.datetime, { utc: true }).toDate(),
            end: newMeeting.end?.date ? dayjs(newMeeting.end?.date).toDate() : dayjs(newMeeting.end?.datetime, { utc: true }).toDate(),
            type: 'meeting',
            attendees: newMeeting.attendees || [],
            location: '',
            description: '',
            transparency: 'transparent',
            sendUpdate: false,
            visibility: 'default',
            allDay: Boolean(newMeeting.allDay),
            eventType: newMeeting.eventType,
          },
        ]
      : [];

    return [...meetingEvents, ...taskboxEvents, ...newTaskboxEvent, ...newMeetingEvent];
  }, [meetings, taskboxes, newTaskbox, newMeeting]);

  const fetchMeetings = async (date: Date, refresh?: boolean) => {
    const meetings = await getEventsV1EventsGet({
      startTime: dayjs(date).startOf('day').format(DATE_FORMAT_1),
      endTime: dayjs(date).endOf('day').add(1, 'day').format(DATE_FORMAT_1),
      refresh,
    });
    return meetings.data || [];
  };

  const fetchTaskBoard = async (from: Date, to: Date) => {
    const diffDay = dayjs(to).diff(from, 'day');
    if (diffDay < 0) return [];

    const data = await readTaskboxesV1TaskboxesGet({
      start_date: dayjs(from).format(DATE_FORMAT_4),
      end_date: dayjs(to).add(1, 'day').format(DATE_FORMAT_4),
      task_view_mode: userState.data.taskViewMode === 'SPLIT' ? 'SPLIT' : 'MERGE',
    });

    const multiDayTaskboxes = data.filter((item) => item.type === 'TERM_TASK').flatMap((v) => v.matchDate!.map((date) => ({ ...v, date })));

    const allDayTaskboxes = data
      .filter((item) => item.type !== 'TERM_TASK' && item.allDay)
      .map((item) => ({ ...item, date: dayjs(item.start?.date).format(DATE_FORMAT_4) }));

    const timeTaskboxes = data
      .filter((item) => item.type !== 'TERM_TASK' && !item.allDay)
      .map((item) => ({ ...item, date: dayjs(item.start?.datetime, { utc: true }).format(DATE_FORMAT_4) }));

    const groups =
      userState.data.taskViewMode === 'SPLIT'
        ? groupBy([...multiDayTaskboxes, ...allDayTaskboxes, ...timeTaskboxes], 'date')
        : groupBy(
            data.map((item) => ({ ...item, date: dayjs(item.start?.date || item.start?.datetime, { utc: true }).format(DATE_FORMAT_4) })),
            'date',
          );

    const days = [...Array(diffDay)].map((_, idx) => dayjs(from).add(idx, 'day').format(DATE_FORMAT_4));

    return [
      ...days.map((item) => ({
        id: item,
        date: dayjs(item).toDate(),
        taskboxes: groups[item]?.map((item) => omit(item, 'date')) || [],
      })),
    ].sort((a, b) => +a.date - +b.date);
  };

  const fetchTaskboxes = async (date: Date) => {
    const dateFormat = dayjs(date).format(DATE_FORMAT_4);
    const taskboxes = await readTaskboxesV1TaskboxesGet({
      start_date: dateFormat,
      end_date: dayjs(dateFormat).add(1, 'day').format(DATE_FORMAT_4),
      task_view_mode: userState.data.taskViewMode === 'SPLIT' ? 'SPLIT' : 'MERGE',
    });
    return taskboxes;
  };

  const fetchIncompleteTaskboxes = async () => {
    const param = undefined;
    const data: OutAutoComplete[] = await readAutocompleteListV1AutocompleteGet(param);
    setIncompleteTaskbox(data);
  };

  const fetchTemplateList = async () => {
    const data = await readFrequentWorksV1FrequentworksGet();
    setTemplateList(data);
  };

  const getTaskBoardElement = (date: Date) => {
    return refTaskView.current?.querySelector(`[data-board-id="${dayjs(date).format(DATE_FORMAT_4)}"]`) as HTMLDivElement;
  };

  const init = async () => {
    setLoading(true);
    await refresh(currentDate);

    setTimeout(() => {
      if (refTaskView && refTaskView?.current) {
        const el = getTaskBoardElement(currentDate);
        if (el) refTaskView?.current.scrollTo({ top: el.offsetTop - 52, behavior: 'auto' });
      }

      setIsFirstLoading(true);
      setTimeout(() => setLoading(false), 100);
    });
  };

  const updateMeetings = async (date: Date) => {
    const meetings = await fetchMeetings(date);
    setMeetings(meetings);
  };

  const updateTaskboxes = async (date: Date) => {
    const dateFormat = dayjs(date).format(DATE_FORMAT_4);
    const taskboxes = await readTaskboxesV1TaskboxesGet({
      start_date: dateFormat,
      end_date: dayjs(dateFormat).add(1, 'day').format(DATE_FORMAT_4),
      task_view_mode: userState.data.taskViewMode === 'SPLIT' ? 'SPLIT' : 'MERGE',
    });
    const multiDayTaskboxes = taskboxes.filter((item) => item.type === 'TERM_TASK');
    const allDayTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && item.allDay);
    const timeTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && !item.allDay);
    const sortedTaskboxes = [...multiDayTaskboxes, ...allDayTaskboxes, ...timeTaskboxes];
    setTaskboxes(userState.data.taskViewMode === 'SPLIT' ? sortedTaskboxes : taskboxes);
    setTaskBoards(
      taskBoards.map((item) => (item.id === dateFormat ? { ...item, taskboxes: userState.data.taskViewMode === 'SPLIT' ? sortedTaskboxes : taskboxes } : item)),
    );
  };

  const updatePeriodTaskboxes = async (current: Date, from: Date, to: Date) => {
    const dateFormat = dayjs(current).format(DATE_FORMAT_4);
    const taskboxes = await readTaskboxesV1TaskboxesGet({
      start_date: dateFormat,
      end_date: dayjs(dateFormat).add(1, 'day').format(DATE_FORMAT_4),
      task_view_mode: userState.data.taskViewMode === 'SPLIT' ? 'SPLIT' : 'MERGE',
    });
    const multiDayTaskboxes = taskboxes.filter((item) => item.type === 'TERM_TASK');
    const allDayTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && item.allDay);
    const timeTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && !item.allDay);
    const sortedTaskboxes = [...multiDayTaskboxes, ...allDayTaskboxes, ...timeTaskboxes];
    const taskBoards = await fetchTaskBoard(from, to);

    setTaskboxes(sortedTaskboxes);
    setTaskBoards(taskBoards);
  };

  const handleRefresh = async () => {
    if (isLoading) return;
    setMeetings([]);
    setTaskboxes([]);
    setLoading(true);
    await refresh(currentDate, true);
    setLoading(false);
    scrollToDateLine(currentDate);
  };

  const [selectedMeeting, setSelectedMeeting] =
    useState<(OutReadEvent & { googleCalendarId?: string; sendUpdate?: boolean; isInvited?: boolean; isUpdated?: boolean }) | undefined>();
  const [originGoogleCalendarId, setOriginGoogleCalendarId] = useState<string | null>(null);

  const handleSelectEvent = async (eventId: string) => {
    const event = calendarEvents.find((item) => item.id === eventId);

    if (event && event.type === 'task') {
      setSelectedEventId(event?.id || undefined);
      return;
    }

    if (event && event.type === 'meeting') {
      const meeting = meetings.find((item) => item.id === eventId);
      setSelectedMeeting(meeting);
      setOriginGoogleCalendarId(meeting?.googleCalendarId || null);
      const el = document.querySelector(`[data-calendar-id="${event.id}"]`) as HTMLElement;
      setMeetingAnchorEl(el);
    }
  };

  const handleUpdateEvent = async ({ eventId, startTime, endTime, isAllDay }: { eventId: string; startTime: string; endTime: string; isAllDay: boolean }) => {
    if (dayjs(startTime).isBefore(dayjs().add(15, 'minute')) && dayjs(startTime).isAfter(dayjs().subtract(15, 'minute'))) {
      if (startNowPopupVisible && startNowPopupVisible.data.popup === undefined) {
        await updateFeatureStorageV1FeatureStorageFeatureStorageIdPatch(startNowPopupVisible.id, {
          data: { popup: true },
        });
        fetchStartNowPopupVisible();
      }
    }

    if (startTime && endTime && Math.abs(dayjs(startTime).diff(endTime, 'minute')) < 15) return; // 15분 미만 변경 불가

    const start = isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime };
    const end = isAllDay ? { date: dayjs(endTime).format(DATE_FORMAT_4) } : { datetime: endTime };

    if (newTaskbox && newTaskbox.id === eventId) {
      setNewTaskbox({ ...newTaskbox, start, end, allDay: isAllDay });
      return;
    }

    const taskbox = taskboxes.find((item) => item.id === eventId);
    if (taskbox) {
      if (taskbox.type === 'TERM_TASK') {
        toast.error('종료일이 지정된 업무는 시간 설정을 할 수 없습니다.');
        return;
      }
      if (taskbox?.isRecurrence) {
        setUpdateRecurringTaskboxParams({
          eventId: taskbox.id!,
          recurrence: taskbox.recurrence as InRecurrence,
          start: { datetime: startTime },
          end: { datetime: endTime },
        });
      } else {
        setTaskboxes(taskboxes.map((item) => (item.id === taskbox.id ? { ...taskbox, start, end, allDay: isAllDay } : item)));
        await updateTaskboxV1TaskboxesTaskboxIdPut(taskbox.id!, {
          ...pick(taskbox, ['lockedIn', 'tasks']),
          start,
          end,
          tasks: taskbox.tasks as UpdateTaskForTaskBox[],
        });
        taskbox.project ? toast.success('인스턴스를 수정하였습니다.') : toast.success('태스크박스를 수정하였습니다.');
        updateTaskboxes(currentDate);
        if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
      }
      return;
    }

    const meeting = meetings.find((item) => item.id === eventId);
    if (meeting) {
      if (!meeting.canModify) {
        toast.error('수정 권한이 없어 일정을 수정할 수 없습니다.');
        return;
      }

      if (meeting.recurringEventId) {
        setUpdateRecurringEventParams({
          ...meeting,
          start: { datetime: startTime },
          end: { datetime: endTime },
        });
      } else {
        setMeetings(meetings.map((item) => (item.id === meeting.id ? { ...meeting, start, end } : item)));
        const { googleCalendarId, ...others } = meeting;
        const updatedMeeting = {
          ...others,
          start,
          end,
        };

        try {
          await updateEventsV1EventsCalendarIdEventIdPut(meeting.googleCalendarId, eventId, updatedMeeting as UpdateEventWithParam);
          await updateMeetings(currentDate);
          toast.success('일정을 수정하였습니다.');
        } catch (error) {
          toast.error('일정을 수정하는데 실패하였습니다.');
        }
      }
    }
  };

  const handleUpdateEventTitle = async ({ eventId, title, isAllDay }: { eventId: string; title: string; isAllDay: boolean }) => {
    if (calendarEventEditing) setCalendarEventEditing(false);
    if (newTaskbox && newTaskbox.id === eventId) {
      if (!title) return;

      const result = await createTaskboxV1TaskboxesPost({
        ...newTaskbox,
        id: newTaskbox.id || uuidv4(),
        title: title,
        done: dayjs(currentDate).isBefore(dayjs(), 'date'),
      });

      if (result) {
        updateTaskboxes(currentDate);
        setNewTaskbox(undefined);
        if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
        toast.success('새로운 태스크박스를 생성하였습니다.');
      }
    } else {
      const taskbox = taskboxes.find((item) => item.id === eventId);
      if (!taskbox) return;
      if (title === taskbox.title) return;

      await updateTaskboxV1TaskboxesTaskboxIdPut(taskbox.id!, {
        ...pick(taskbox, ['lockedIn', 'start', 'end']),
        title,
        tasks: taskbox.tasks as UpdateTaskForTaskBox[],
      });
      updateTaskboxes(currentDate);
      if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
      taskbox.project ? toast.success('인스턴스를 수정하였습니다.') : toast.success('태스크박스를 수정하였습니다.');
    }
  };

  const handleChangeEventEditing = () => {
    setCalendarEventEditing(true);
  };

  const [meetingAnchorEl, setMeetingAnchorEl] = useState<HTMLElement | null>(null);
  const [isOptionPressed, setIsOptionPressed] = useState(false);

  useEffect(() => {
    if (isOptionPressed) {
      setTimeout(() => {
        setIsOptionPressed(false);
      }, 1500);
    }
  }, [isOptionPressed]);

  const handleClickTimeSlot = async ({ startTime, endTime, isAllDay }: { startTime: string; endTime: string; isAllDay: boolean }) => {
    const id = uuidv4();
    // if (newTaskbox) {
    //   const target = document.querySelector('.today-calendar-title') as HTMLElement;
    //   if (target) target.blur();
    // }
    // await new Promise((resolve) => setTimeout(resolve, 100));

    if (isOptionPressed) {
      setNewMeeting((prevMeeting) => {
        if (prevMeeting)
          return {
            ...prevMeeting,
            id: id,
            summary: '',
            start: isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime },
            end: isAllDay ? { date: dayjs(endTime).format(DATE_FORMAT_4) } : { datetime: endTime },
            allDay: isAllDay,
            eventType: 'default',
          };
        else
          return {
            id: id,
            summary: '',
            start: isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime },
            end: isAllDay ? { date: dayjs(endTime).format(DATE_FORMAT_4) } : { datetime: endTime },
            allDay: isAllDay,
            eventType: 'default',
          };
      });

      setTimeout(() => {
        const el = document.querySelector(`[data-calendar-id="${id}"]`) as HTMLElement;
        setMeetingAnchorEl(el);
        setIsOptionPressed(false);
      }, 100);
      return;
    }

    setNewTaskbox((prevTaskbox) => {
      if (prevTaskbox)
        return {
          ...prevTaskbox,
          id: id,
          start: isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime },
          end: isAllDay ? { date: dayjs(endTime).format(DATE_FORMAT_4) } : { datetime: endTime },
          allDay: isAllDay,
        };
      else
        return {
          id: id,
          title: '',
          tasks: [],
          start: isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime },
          end: isAllDay ? { date: dayjs(endTime).format(DATE_FORMAT_4) } : { datetime: endTime },
          allDay: isAllDay,
        };
    });

    setSelectedEventId(id);
  };

  const handleDropFromOutside = async ({ startTime, endTime, isAllDay }: { startTime: string; endTime: string; isAllDay: boolean }) => {
    if (!taskViewDragContext) return;

    const { id, type, title, view, data, projectId } = taskViewDragContext;
    const taskList: { id: string; content: string; type: string }[] = [];
    const entireBoardTaskboxes = taskBoards.flatMap((item) => item.taskboxes);
    const taskbox = entireBoardTaskboxes.find((item) => item.id === id);
    const isBefore = dayjs(currentDate).isBefore(dayjs(), 'date');

    if (Array.isArray(data)) {
      for (const item of data) {
        taskList.push({ id: item.id, content: item.title, type: item.type });
      }
    }

    if (view === 'backlog') {
      let result;
      if (taskList.length > 1) {
        //태스크그룹으로 묶고 일지로
        const taskIds = taskList.filter((item) => item.type === 'SOMEDAY_TASK').map((item) => item.id);
        const taskboxIds = taskList.filter((item) => item.type === 'SOMEDAY_TASKBOX').map((item) => item.id);
        const merge = await mergeWorkOrWorkBoxesV2V2WorksMergePost({ taskIds: [...taskIds], taskboxIds: [...taskboxIds] });
        result =
          merge &&
          (await updateWorkboxesV2V2WorkboxesWorkboxIdPut(merge.id, {
            start: { datetime: dayjs(startTime).format(DATE_FORMAT_1) },
            end: { datetime: dayjs(startTime, { utc: true }).add(1, 'hour').format(DATE_FORMAT_1) },
            done: isBefore,
          }));
      } else if (taskList.length === 1) {
        result = await updateWorkboxesV2V2WorkboxesWorkboxIdPut(taskList[0].id, {
          start: { datetime: dayjs(startTime, { utc: true }).format(DATE_FORMAT_1) },
          end: { datetime: dayjs(startTime, { utc: true }).add(1, 'hour').format(DATE_FORMAT_1) },
          done: isBefore,
        });
      }

      if (result) {
        toast.success('새로운 태스크박스를 생성하였습니다.');
        await updateTaskboxes(currentDate);
        if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) {
          fetchIncompleteTaskboxes();
        }
        updateTodoTasks();
      }

      return;
    }

    if (view === 'taskboard') {
      if (type === 'multi-taskbox' && Array.isArray(data) && data.length > 0) {
        const diffDay = dayjs(startTime).diff(endTime, 'day');
        if (Math.abs(diffDay) > 0) return;

        const updateTaskbox = async (taskbox: OutTaskboxDetailResponse) => {
          const diffTime = dayjs(taskbox.end?.datetime).diff(taskbox.start?.datetime, 'minute');
          const start = isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime };
          const end = isAllDay
            ? { date: dayjs(endTime).format(DATE_FORMAT_4) }
            : {
                datetime: dayjs(startTime, { utc: true })
                  .add(taskbox.durationMin ? taskbox.durationMin : 60, 'minute')
                  .format(DATE_FORMAT_1),
              };

          if (taskbox.start?.datetime && taskbox.end?.datetime) {
            end.datetime = dayjs(startTime, { utc: true }).add(diffTime, 'minute').format(DATE_FORMAT_1);
          }

          if (taskbox.isRecurrence) {
            setUpdateRecurringTaskboxParams({
              eventId: taskbox.id!,
              recurrence: taskbox.recurrence as InRecurrence,
              start: start,
              end: end,
            });
          } else {
            const result = await updateTaskboxV1TaskboxesTaskboxIdPut(taskbox.id!, {
              ...taskbox,
              start,
              end,
              done: isBefore,
              tasks: taskbox.tasks as UpdateTaskForTaskBox[],
            });
            if (result) {
              taskbox.project ? toast.success('인스턴스를 수정하였습니다.') : toast.success('태스크박스를 수정하였습니다.');
              if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
              if (dayjs(taskbox.start?.date || taskbox.start?.datetime, { ute: true }).isSame(dayjs(currentDate), 'date')) {
                updateTaskboxes(currentDate);
              } else {
                handleChangeStartAndEndTaskBoard(dayjs(taskbox.start?.date || taskbox.start?.datetime, { utc: true }).toDate(), currentDate);
              }
            }
          }
        };

        const taskboxList = entireBoardTaskboxes.filter((item) => data.includes(item.id));
        await Promise.all(taskboxList.map(updateTaskbox));
      } else if (type === 'subtask') {
        const start = isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime };
        const end = isAllDay
          ? { date: dayjs(endTime).format(DATE_FORMAT_4) }
          : {
              datetime: dayjs(startTime, { utc: true }).add(60, 'minute').format(DATE_FORMAT_1),
            };

        const create = await createTaskboxV1TaskboxesPost(
          projectId
            ? {
                id: uuidv4(),
                title: '',
                start: start,
                end: end,
                projectId: [projectId],
                done: isBefore,
              }
            : {
                id: uuidv4(),
                title: title!,
                start: start,
                end: end,
                done: isBefore,
                categoryId: taskbox && taskbox.category && [taskbox?.category?.id],
                deadline: taskbox?.deadline,
              },
        );

        if (create && create.id) {
          projectId
            ? await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(create.id, {
                beforeId: null,
                taskIds: data.map((task: any) => task.id!),
                done: isBefore,
              })
            : await assignTasksV1TaskboxesTaskboxIdAssignPost(create.id, {
                tasks: data.map((task: any) => task.id!),
                done: isBefore,
              });
        }

        if (dayjs(taskbox?.start?.date || taskbox?.start?.datetime, { ute: true }).isSame(dayjs(currentDate), 'date')) {
          updateTaskboxes(currentDate);
        } else {
          handleChangeStartAndEndTaskBoard(dayjs(taskbox?.start?.date || taskbox?.start?.datetime, { utc: true }).toDate(), currentDate);
        }
      } else if (type === 'multi-subtask') {
        const start = isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime };
        const end = isAllDay
          ? { date: dayjs(endTime).format(DATE_FORMAT_4) }
          : {
              datetime: dayjs(startTime, { utc: true }).add(60, 'minute').format(DATE_FORMAT_1),
            };

        const create = await createTaskboxV1TaskboxesPost(
          projectId
            ? {
                id: uuidv4(),
                title: '',
                start: start,
                end: end,
                projectId: [projectId],
                done: isBefore,
              }
            : {
                id: uuidv4(),
                title: title!,
                start: start,
                end: end,
                done: isBefore,
                categoryId: taskbox && taskbox.category && [taskbox?.category?.id],
                deadline: taskbox?.deadline,
              },
        );

        if (create && create.id) {
          projectId
            ? await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(create.id, {
                beforeId: null,
                taskIds: data,
                done: isBefore,
              })
            : await assignTasksV1TaskboxesTaskboxIdAssignPost(create.id, {
                tasks: data,
                done: isBefore,
              });
        }

        if (dayjs(taskbox?.start?.date || taskbox?.start?.datetime, { ute: true }).isSame(dayjs(currentDate), 'date')) {
          updateTaskboxes(currentDate);
        } else {
          handleChangeStartAndEndTaskBoard(dayjs(taskbox?.start?.date || taskbox?.start?.datetime, { utc: true }).toDate(), currentDate);
        }
        setMeetingAnchorEl(null);
        setMultiSelectSubtaskIds([]);
      } else {
        if (taskbox) {
          const diffTime = dayjs(taskbox.end?.datetime).diff(taskbox.start?.datetime, 'minute');
          const diffDay = dayjs(startTime).diff(endTime, 'day');
          if (Math.abs(diffDay) > 0) return;

          const start = isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime };
          const end = isAllDay
            ? { date: dayjs(endTime).format(DATE_FORMAT_4) }
            : {
                datetime: dayjs(startTime, { utc: true })
                  .add(taskbox.durationMin ? taskbox.durationMin : 60, 'minute')
                  .format(DATE_FORMAT_1),
              };

          if (taskbox.start?.datetime && taskbox.end?.datetime) {
            end.datetime = dayjs(startTime, { utc: true }).add(diffTime, 'minute').format(DATE_FORMAT_1);
          }

          if (taskbox?.isRecurrence) {
            setUpdateRecurringTaskboxParams({
              eventId: taskbox.id!,
              recurrence: taskbox.recurrence as InRecurrence,
              start: start,
              end: end,
            });
          } else {
            const result = await updateTaskboxV1TaskboxesTaskboxIdPut(id!, {
              ...taskbox,
              start: start,
              end: end,
              done: isBefore,
              tasks: taskbox.tasks as UpdateTaskForTaskBox[],
            });
            if (result) {
              taskbox.project ? toast.success('인스턴스를 수정하였습니다.') : toast.success('태스크박스를 수정하였습니다.');
              if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
              if (dayjs(taskbox.start?.date || taskbox.start?.datetime, { ute: true }).isSame(dayjs(currentDate), 'date')) {
                updateTaskboxes(currentDate);
              } else {
                handleChangeStartAndEndTaskBoard(dayjs(taskbox.start?.date || taskbox.start?.datetime, { utc: true }).toDate(), currentDate);
              }
            }
          }
        }
      }
    }

    if (view === 'side-project') {
      const start = isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime };
      const end = isAllDay
        ? { date: dayjs(endTime).format(DATE_FORMAT_4) }
        : { datetime: dayjs(startTime, { utc: true }).add(60, 'minute').format(DATE_FORMAT_1) };

      try {
        const result = await createTaskboxV1TaskboxesPost({
          id: uuidv4(),
          title: '',
          start: start,
          end: end,
          projectId: id ? [id] : null,
          done: isBefore,
        });

        if (result) {
          toast.success('프로젝트의 인스턴스를 생성하였습니다.');
          if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
          updateTaskboxes(currentDate);
          fetchProjects();
        }
      } catch (error) {
        toast.error('프로젝트의 인스턴스를 생성하는데 실패하였습니다.');
      }
      return;
    }

    if (view === 'project-detail') {
      const start = isAllDay ? { date: dayjs(startTime).format(DATE_FORMAT_4) } : { datetime: startTime };
      const end = isAllDay
        ? { date: dayjs(endTime).format(DATE_FORMAT_4) }
        : { datetime: dayjs(startTime, { utc: true }).add(60, 'minute').format(DATE_FORMAT_1) };

      try {
        const create = await createTaskboxV1TaskboxesPost({
          id: uuidv4(),
          title: '',
          start: start,
          end: end,
          projectId: projectId ? [projectId] : null,
          beforeId: null,
          done: isBefore,
        });

        if (create && create.id) {
          await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(create.id, {
            beforeId: null,
            taskIds: type === 'project-multi-subtask' ? data : data.map((task: any) => task.id!),
            done: isBefore,
          });
        }
        toast.success('프로젝트의 인스턴스를 생성하였습니다.');
        updateTaskboxes(currentDate);
        fetchProjects();
      } catch (error) {
        toast.error('프로젝트의 인스턴스를 생성하는데 실패하였습니다.');
      }
    }
  };

  const handleClickTaskSelection = async (tasks: TaskSelectionViewTask[]) => {
    if (!taskSelectionModal) return;
    const { id, issueTitle, start, end } = taskSelectionModal;

    setTaskSelectionModal(null);
    const result = await createTaskboxV1TaskboxesPost({
      id: uuidv4(),
      title: issueTitle!,
      start: start,
      end: end,
      tasks: tasks.map((item) => ({ id: item.id!, content: item.content || '' })),
      issueId: id,
    });

    if (result) {
      toast.success('새로운 태스크박스를 생성하였습니다.');
      if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
      updateTaskboxes(currentDate);
      await removeTaskV1WorksWorkIdDelete(id!);
    }
  };

  const handleClickCreateTaskBoard = (date: Date) => {
    if (boardWritingStatus.get(dayjs(date).format(DATE_FORMAT_4))) {
      const newBoardWritingStatus = new Map(boardWritingStatus);
      newBoardWritingStatus.delete(dayjs(date).format(DATE_FORMAT_4));
      setBoardWritingStatus(newBoardWritingStatus);
    } else {
      setBoardWritingStatus(new Map(boardWritingStatus).set(dayjs(date).format(DATE_FORMAT_4), true));
      scrollToDateLine(date);
    }
  };

  const handleAddTaskbox = async (date: Date, taskbox: CreateTaskbox) => {
    if (!taskbox) return;
    const dateFormat = dayjs(date).format(DATE_FORMAT_4);
    const start = { date: dateFormat };
    const end = { date: dayjs(dateFormat).add(1, 'day').format(DATE_FORMAT_4) };
    const result = await createTaskboxV1TaskboxesPost({
      id: uuidv4(),
      title: taskbox.title,
      start: start,
      end: end,
      done: dayjs(date).isBefore(dayjs(), 'date'),
      categoryId: taskbox.categoryId,
      deadline: taskbox.deadline,
    });
    if (result) {
      toast.success('새로운 태스크박스를 생성하였습니다.');
      updateTaskboxes(date);
      fetchIncompleteTaskboxes();
    }
  };

  const handleChangeCurrentDate = async (date: Date) => {
    setSuppressScrollEvent(true);

    const dateValue = dayjs(date).format(DATE_FORMAT_4);
    if (taskBoards.map((item) => dayjs(item.date).format(DATE_FORMAT_4)).includes(dateValue)) {
      updateMeetings(date);
      updateTaskboxes(date);
      scrollToDateLine(date, 'auto');
      setCurrentDate(date);
      setCurrentTaskBoardDate(date);
    } else {
      await refresh(date);
      scrollToDateLine(date);
    }

    setTimeout(() => setSuppressScrollEvent(false), 1000);
  };

  // const handleViewportOnView = async (date: Date | undefined) => {
  //   if (isLoading) return;
  //   if (suppressScrollEvent) return;
  // const handleViewportOnView = async (date: Date | undefined) => {
  //   if (isLoading) return;
  //   if (suppressScrollEvent) return;

  //   TODO  : 일지 포커싱 직관성 개선 => 사용 후 피드백 좋지 않으면 롤백
  //   setCurrentTaskBoardDate(date);
  //   setCurrentDateInViewport(date);

  //   setCurrentDate(date);
  //   debounceFetch(date);
  // };

  const handleChangeTaskBoard = async (startDate: Date, endDate?: Date, move?: boolean) => {
    setSuppressScrollEvent(true);
    if (move) setSelectedEventId(undefined);

    if (endDate) {
      updatePeriodTaskboxes(startDate, dayjs(startDate).toDate(), dayjs(endDate).add(1, 'day').toDate());
    } else {
      const [meetings, taskboxes] = await Promise.all([fetchMeetings(startDate), fetchTaskboxes(startDate)]);

      if (dayjs(startDate).isSame(currentDate, 'day')) {
        setMeetings(meetings);
        setTaskboxes(taskboxes);
      }

      const multiDayTaskboxes = taskboxes.filter((item) => item.type === 'TERM_TASK');
      const allDayTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && item.allDay);
      const timeTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && !item.allDay);
      const sortedTaskboxes = [...multiDayTaskboxes, ...allDayTaskboxes, ...timeTaskboxes];
      setTaskBoards((state) =>
        state.map((item) =>
          item.id === dayjs(startDate).format(DATE_FORMAT_4)
            ? { ...item, taskboxes: userState.data.taskViewMode === 'SPLIT' ? sortedTaskboxes : taskboxes }
            : item,
        ),
      );
    }
    setSuppressScrollEvent(false);
  };

  const handleChangeStartAndEndTaskBoard = async (startDate: Date, endDate?: Date, move?: boolean) => {
    setSuppressScrollEvent(true);
    if (move) setSelectedEventId(undefined);
    const [startDateTaskboxes, endDateTaskboxes] = await Promise.all([fetchTaskboxes(startDate), fetchTaskboxes(endDate!)]);

    setTaskBoards((state) => state.map((item) => (item.id === dayjs(startDate).format(DATE_FORMAT_4) ? { ...item, taskboxes: startDateTaskboxes } : item)));
    setTaskBoards((state) => state.map((item) => (item.id === dayjs(endDate).format(DATE_FORMAT_4) ? { ...item, taskboxes: endDateTaskboxes } : item)));

    setSuppressScrollEvent(false);
  };

  const handleClickBeforeDate = async () => {
    if (isLoading) return;

    if (refTaskView.current && refTaskView.current.scrollTop === 0) {
      refTaskView.current.scrollTop = 1;
    }

    const date = taskBoards?.length > 0 ? taskBoards[0].date : currentDate;
    const from = dayjs(date).subtract(7, 'day').toDate();
    const to = dayjs(date).subtract(0, 'day').toDate();

    setLoading(true);
    setSuppressScrollEvent(true);

    const prevTaskBoards = await fetchTaskBoard(from, to);
    const yesterday = dayjs(date).subtract(1, 'day').toDate();
    setTaskBoards([...prevTaskBoards, ...taskBoards]);
    setBoardWritingStatus(
      new Map(
        [...prevTaskBoards, ...taskBoards]
          .filter((item) => item.taskboxes.length || dayjs(item.date).isToday() || dayjs(item.date).isTomorrow())
          .map((item) => [item.id, true]),
      ),
    );
    setCurrentDate(yesterday);
    setLoading(false);
    setTimeout(() => {
      if (refTaskView && refTaskView?.current) {
        const el = getTaskBoardElement(yesterday);
        if (el) {
          const isChrome = getBrowserName() === 'Chrome';
          refTaskView?.current.scrollTo({ top: el.offsetTop - 52, behavior: isChrome ? 'smooth' : 'auto' });
        }
      }

      setTimeout(() => setSuppressScrollEvent(false), 100);
    }, 30);
  };

  const handleClickExpand = (date: Date) => {
    const expanded = boardExpandStatus.get(dayjs(date).format(DATE_FORMAT_4)) !== false;
    const newBoardExpandStatus = new Map(boardExpandStatus).set(dayjs(date).format(DATE_FORMAT_4), !expanded);
    setBoardExpandStatus(newBoardExpandStatus);
    localStorage.setItem('task-board-expand-status', JSON.stringify([...newBoardExpandStatus]));
  };

  const scrollToDateLine = async (date: Date, behavior: ScrollBehavior = 'smooth') => {
    setTimeout(() => {
      if (refTaskView && refTaskView?.current) {
        const el = refTaskView?.current.querySelector(`[data-board-id="${dayjs(date).format(DATE_FORMAT_4)}"]`) as HTMLDivElement;
        if (el) refTaskView?.current.scrollTo({ top: el.offsetTop - 52, behavior: behavior });
      }
    }, 30);
  };

  const handleClickTaskbox = async (date: Date, taskboxId: string) => {
    if (isLoading) return;
    if (suppressScrollEvent) return;

    setSuppressScrollEvent(true);
    setCurrentDate(date);
    if (dayjs(date).get('date') !== dayjs(currentDate).get('date')) {
      const [meetings, taskboxes] = await Promise.all([fetchMeetings(date), fetchTaskboxes(date)]);
      setMeetings(meetings);
      setTaskboxes(taskboxes);
      setTaskBoards((state) => state.map((item) => (item.id === dayjs(date).format(DATE_FORMAT_4) ? { ...item, taskboxes: taskboxes } : item)));
    }
    setSelectedEventId(taskboxId);
    setSuppressScrollEvent(false);
  };

  const handleClickSubtask = (subTaskId: string) => {
    setSelectedSubtaskId(subTaskId);
  };

  const handleDropTaskOnTaskBoard = async (date: Date) => {
    if (!taskViewDragContext) return;
    const taskbox = taskboxes.find((item) => item.id === taskViewDragContext.id);
    const dateFormat = dayjs(date).format(DATE_FORMAT_4);
    const start = { date: dateFormat };
    const end = { date: dayjs(dateFormat).add(1, 'day').format(DATE_FORMAT_4) };
    const { id, type, view, data, projectId } = taskViewDragContext;
    const taskList: { id: string; content: string; type: string }[] = [];
    const isBefore = dayjs(date).isBefore(dayjs(), 'date');
    const targetTaskboard = taskBoards.find((taskboard) => dayjs(taskboard.date).isSame(date, 'date'));
    if (!targetTaskboard) return;
    const sameProjectInstance = targetTaskboard.taskboxes.find((taskbox) => taskbox.project?.id === projectId && taskbox.allDay && taskbox.project);

    if (Array.isArray(data)) {
      for (const item of data) {
        taskList.push({ id: item.id, content: item.title, type: item.type });
      }
    }

    if (view === 'backlog') {
      if (taskList.length > 1) {
        //태스크그룹으로 묶고 일지로
        const taskboxIds = taskList.map((item) => item.id);
        const merge = await mergeWorkOrWorkBoxesV2V2WorksMergePost({ taskboxIds: [...taskboxIds] });
        const result = merge && (await updateWorkboxesV2V2WorkboxesWorkboxIdPut(merge.id, { start: start, end: end, beforeId: null, done: isBefore }));

        if (result) {
          toast.success('새로운 태스크박스를 생성하였습니다.');
          if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) {
            fetchIncompleteTaskboxes();
          }

          if (!dayjs(date).isSame(dayjs(currentDate), 'date')) {
            updateTaskboxes(date);
            await new Promise((resolve) => setTimeout(resolve, 100));
          }
          updateTodoTasks();
        }
      } else if (taskList.length === 1) {
        const result = await updateWorkboxesV2V2WorkboxesWorkboxIdPut(taskList[0].id, {
          start: start,
          end: end,
          beforeId: null,
          done: isBefore,
        });

        if (result) {
          toast.success('새로운 태스크박스를 생성하였습니다.');
          if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) {
            fetchIncompleteTaskboxes();
          }

          if (!dayjs(date).isSame(dayjs(currentDate), 'date')) {
            updateTaskboxes(date);
            await new Promise((resolve) => setTimeout(resolve, 100));
          }
          updateTodoTasks();
        }
      }
      return;
    }

    if (view === 'taskboard') {
      if (type === 'taskbox') {
        const result = isBefore
          ? await updateTaskboxV1TaskboxesTaskboxIdPut(id!, { start: start, end: end, beforeId: null, done: true })
          : await updateTaskboxV1TaskboxesTaskboxIdPut(id!, { start: start, end: end, beforeId: null });
        if (result) {
          toast.success('태스크박스를 수정하였습니다.');
          handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
          if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
        }
      } else if (type === 'multi-taskbox') {
        await Promise.all(
          data.map((id: string) => {
            return isBefore
              ? updateTaskboxV1TaskboxesTaskboxIdPut(id, {
                  start: start,
                  end: end,
                  done: true,
                })
              : updateTaskboxV1TaskboxesTaskboxIdPut(id, {
                  start: start,
                  end: end,
                });
          }),
        );
        toast.success('태스크박스를 수정하였습니다.');
        handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
        if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
      } else if (type === 'instance') {
        if (sameProjectInstance && sameProjectInstance.id) {
          try {
            const assign = await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(sameProjectInstance.id, { taskIds: [id!] });
            if (assign) {
              toast.success('해당 날짜에 동일한 프로젝트의 인스턴스가 존재해 하나로 합쳤어요');
              handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
              fetchProjects();
              if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
            }
          } catch (error) {
            toast.error('인스턴스를 해당 날짜의 일지로 옮길 수 없습니다.');
          }
        } else {
          try {
            isBefore
              ? await updateTaskboxV1TaskboxesTaskboxIdPut(id!, { start: start, end: end, done: true })
              : await updateTaskboxV1TaskboxesTaskboxIdPut(id!, { start: start, end: end });
            toast.success('인스턴스를 수정하였습니다.');
            handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
          } catch (error) {
            toast.error('인스턴스를 해당 날짜의 일지로 옮길 수 없습니다.');
          }
        }
      } else if (type === 'subtask') {
        if (sameProjectInstance && sameProjectInstance.id) {
          try {
            const assign = await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(sameProjectInstance.id, {
              taskIds: data.map((task: any) => task.id!),
              done: isBefore,
            });
            if (assign) {
              toast.success('해당 날짜에 동일한 프로젝트의 인스턴스가 존재해 하나로 합쳤어요');
              handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
              fetchProjects();
              if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
            }
          } catch (error) {
            toast.error('인스턴스를 해당 날짜의 일지로 옮길 수 없습니다.');
          }
        } else {
          try {
            const create = await createTaskboxV1TaskboxesPost(
              projectId
                ? {
                    id: uuidv4(),
                    title: '',
                    start: start,
                    end: end,
                    projectId: [projectId],
                    beforeId: null,
                    done: isBefore,
                  }
                : {
                    id: uuidv4(),
                    title: taskViewDragContext.title!,
                    start: start,
                    end: end,
                    beforeId: null,
                    done: isBefore,
                    categoryId: taskbox && taskbox.category && [taskbox?.category?.id],
                    deadline: taskbox?.deadline,
                  },
            );

            if (create && create.id) {
              projectId
                ? await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(create.id, {
                    beforeId: null,
                    taskIds: data.map((task: any) => task.id!),
                    done: isBefore,
                  })
                : await assignTasksV1TaskboxesTaskboxIdAssignPost(create.id, {
                    tasks: data.map((task: any) => task.id!),
                    done: isBefore,
                  });
            }
            handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
            fetchProjects();
          } catch (error) {
            projectId ? toast.error('프로젝트의 인스턴스를 생성하는데 실패하였습니다.') : toast.error('태스크박스를 생성하는데 실패하였습니다.');
          }
        }
      } else if (type === 'multi-subtask') {
        if (sameProjectInstance && sameProjectInstance.id) {
          try {
            const assign = await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(sameProjectInstance.id, {
              taskIds: data,
              done: isBefore,
            });
            if (assign) {
              toast.success('해당 날짜에 동일한 프로젝트의 인스턴스가 존재해 하나로 합쳤어요');
              handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
              fetchProjects();
              if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
            }
          } catch (error) {
            toast.error('인스턴스를 해당 날짜의 일지로 옮길 수 없습니다.');
          }
        } else {
          try {
            const create = await createTaskboxV1TaskboxesPost(
              projectId
                ? {
                    id: uuidv4(),
                    title: '',
                    start: start,
                    end: end,
                    projectId: [projectId],
                    beforeId: null,
                    done: isBefore,
                  }
                : {
                    id: uuidv4(),
                    title: taskViewDragContext.title!,
                    start: start,
                    end: end,
                    beforeId: null,
                    done: isBefore,
                    categoryId: taskbox && taskbox.category && [taskbox?.category?.id],
                    deadline: taskbox?.deadline,
                  },
            );

            if (create && create.id) {
              projectId
                ? await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(create.id, {
                    beforeId: null,
                    taskIds: data,
                    done: isBefore,
                  })
                : await assignTasksV1TaskboxesTaskboxIdAssignPost(create.id, {
                    tasks: data,
                    done: isBefore,
                  });
            }
            handleChangeStartAndEndTaskBoard(taskViewDragContext.date!, date);
            fetchProjects();
          } catch (error) {
            projectId ? toast.error('프로젝트의 인스턴스를 생성하는데 실패하였습니다.') : toast.error('태스크박스를 생성하는데 실패하였습니다.');
          }
        }

        setMultiSelectAnchorEl(null);
        setMultiSelectSubtaskIds([]);
      }
      return;
    }

    if (view === 'side-project') {
      const result = await createTaskboxV1TaskboxesPost({
        id: uuidv4(),
        title: '',
        start: start,
        end: end,
        projectId: [taskList[0].id],
        beforeId: null,
        done: isBefore,
      });

      if (result) {
        toast.success('프로젝트의 인스턴스를 생성하였습니다.');
        updateTaskboxes(date);
        fetchProjects();
      }
      return;
    }

    if (view === 'project-detail') {
      if (sameProjectInstance && sameProjectInstance.id) {
        try {
          const assign = await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(sameProjectInstance.id, {
            taskIds: type === 'project-multi-subtask' ? data : data.map((task: any) => task.id!),
            done: isBefore,
          });
          if (assign) {
            toast.success('해당 날짜에 동일한 프로젝트의 인스턴스가 존재해 하나로 합쳤어요');
            updateTaskboxes(date);
            fetchProjects();
            if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
          }
        } catch (error) {
          toast.error('인스턴스를 해당 날짜의 일지로 옮길 수 없습니다.');
        }
        return;
      } else {
        try {
          const create = await createTaskboxV1TaskboxesPost({
            id: uuidv4(),
            title: '',
            start: start,
            end: end,
            projectId: projectId ? [projectId] : null,
            beforeId: null,
            done: isBefore,
          });

          if (create && create.id) {
            await absorbProjectTasksV1TaskboxesTaskboxIdSubtaskFromProjectPost(create.id, {
              beforeId: null,
              taskIds: type === 'project-multi-subtask' ? data : data.map((task: any) => task.id!),
              done: isBefore,
            });
          }
          updateTaskboxes(date);
          fetchProjects();
        } catch (error) {
          toast.error('프로젝트의 인스턴스를 생성하는데 실패하였습니다.');
        }
      }
    }
  };

  //튜토리얼
  const handleClickTutorialButton = (id: string) => {
    const anchorEl = document.getElementById(id);
    if (anchorEl) setTutorialAnchorEl(anchorEl);
  };

  const handleCloseTutorial = async () => {
    setTutorialAnchorEl(null);
    setTutorialStatus(true);

    if (user?.tutorialStatus === false) {
      const success = await updateMyProfileV1UsersMePatch({
        tutorialStatus: true,
      });
      if (success) user.tutorialStatus = true;
    }
  };

  const handleClickTutorialReplay = () => {
    setTutorialReplay(true);
  };

  const handleCloseTutorialReplay = () => {
    setTutorialReplay(false);
  };

  const handleUpdateRecurrenceTask = async (target: InCreateTaskBoxInRecurrenceTarget) => {
    if (!updateRecurringTaskboxParams) return;
    const { eventId, recurrence, start, end } = updateRecurringTaskboxParams;
    const from = taskBoards[0].date;
    const to = taskBoards[taskBoards.length - 1].date;
    const taskbox = taskboxes.find((item) => item.id === eventId);
    await updateRecurringTaskboxesV1TaskboxesTaskboxIdRecurrencesPatch(eventId, {
      target,
      recurrence,
      start,
      end,
      isCancelled: recurrence.interval === 0,
    } as UpdateTaskBoxRecurrence);
    await updatePeriodTaskboxes(currentDate, from, to);
    taskbox?.project ? toast.success('인스턴스를 수정하였습니다.') : toast.success('태스크박스를 수정하였습니다.');
    setUpdateRecurringTaskboxParams(null);
  };

  const handleUpdateRecurrenceEvent = async (target: InCreateTaskBoxInRecurrenceTarget) => {
    if (!updateRecurringEventParams) return;
    const { googleCalendarId, ...others } = updateRecurringEventParams;
    try {
      await updateEventsV1EventsCalendarIdEventIdPut(googleCalendarId, updateRecurringEventParams.id, {
        ...(originGoogleCalendarId !== googleCalendarId ? updateRecurringEventParams : others),
        target,
      } as UpdateEventWithParam);
      await updateMeetings(currentDate);
      toast.success('일정을 수정하였습니다');
      setUpdateRecurringEventParams(null);
      setMeetingAnchorEl(null);
      setSelectedMeeting(undefined);
    } catch (error) {
      toast.error('일정을 수정하는데 실패하였습니다');
    }

    // await updateEventsV1EventsCalendarIdEventIdPut(updateRecurringTaskboxParams?.eventId!, {});
  };

  const handleCloseMultiSelect = () => {
    setMultiSelectAnchorEl(null);
    setMultiSelectTaskboxIds([]);
  };

  const handleChangeMultiSelect = (id: string, e?: React.MouseEvent<HTMLDivElement>) => {
    if (taskboxes.find((item) => item.id === id)?.type === 'TERM_TASK') {
      toast.error('종료일이 지정된 업무는 다중 선택을 할 수 없습니다.');
      return;
    }

    if (multiSelectSubtaskIds.length > 0) return;

    if (e && (e.ctrlKey || e.metaKey)) {
      if (multiSelectTaskboxIds.includes(id)) {
        setMultiSelectTaskboxIds(multiSelectTaskboxIds.filter((item) => item !== id));
      } else {
        setMultiSelectTaskboxIds([...multiSelectTaskboxIds, id]);
        setMultiSelectAnchorEl(e.currentTarget);
      }
    } else {
      setTimeout(() => {
        if (multiSelectTaskboxIds.includes(id)) {
          setMultiSelectTaskboxIds(multiSelectTaskboxIds.filter((item) => item !== id));
        } else {
          const anchorEl = document.querySelector(`[data-taskbox="${id}"]`) as HTMLElement;
          setMultiSelectTaskboxIds([...multiSelectTaskboxIds, id]);
          setMultiSelectAnchorEl(anchorEl);
        }
      }, 100);
    }
  };

  const handleChangeMultiSelectList = (id: string[]) => {
    const lastId = id[id.length - 1];
    const anchorEl = document.querySelector(`[data-taskbox="${lastId}"]`) as HTMLElement;
    setSelectedEventId(undefined);
    setTimeout(() => {
      setMultiSelectAnchorEl(anchorEl);
      setMultiSelectTaskboxIds([...id]);
    }, 100);
  };

  const handleMultiSelectAnchorElNull = () => {
    setMultiSelectAnchorEl(null);
  };

  const handleClickFoldCalendarView = () => {
    setFoldCalendar(!foldCalendar);
    localStorage.setItem('fold-calendar-view', JSON.stringify(!foldCalendar));
    setIsHoverWidthLine(false);
    if (selectedEventId) setSelectedEventId(undefined);
  };

  //TODO
  const handleClickTaskBoard = (id: string, date: Date) => {
    // if (date !== currentDate) {
    //   setCurrentDate(date);
    //   setCurrentTaskBoardDate(date);
    //   debounceFetch(date);
    //   if (!selectedEventId) {
    //     const taskView = document.getElementById('task-view');
    //     const taskBoard = document.querySelector(`[data-board-id="${id}"]`) as HTMLDivElement;
    //     taskView?.scrollTo({ top: taskBoard?.offsetTop - 12, behavior: 'smooth' });
    //   }
    // }

    setCurrentDate(date);
    setCurrentTaskBoardDate(date);
    if (date !== currentDate) debounceFetch(date);
    if (!selectedEventId) {
      const taskView = document.getElementById('task-view');
      const taskBoard = document.querySelector(`[data-board-id="${id}"]`) as HTMLDivElement;
      taskView?.scrollTo({ top: taskBoard?.offsetTop - 52, behavior: 'smooth' });
    }
  };

  const handleEventContextMenu = async (eventId: string) => {
    const event = calendarEvents.find((item) => item.id === eventId);
    if (!event) return;

    const taskbox = taskboxes.find((item) => item.id === event?.id);
    if (!taskbox) return;

    const el = document.querySelector(`[data-calendar-id="${eventId}"]`) as HTMLElement;
    if (el && el.parentElement) setTaskboxDetailAnchorEl(el.parentElement);
    setContextTaskbox(taskbox);
  };

  const handleTaskboxContextMenu = async (taskboxId: string) => {
    const taskbox = taskboxes.find((item) => item.id === taskboxId);
    if (!taskbox) return;

    const el = document.querySelector(`[data-taskbox="${taskboxId}"]`) as HTMLElement;
    if (el) setTaskboxDetailAnchorEl(el);
    setContextTaskbox(taskbox);
  };

  const handleClickContextMenu = async (id: string, type: string, menu: InboxContextMenuType) => {
    try {
      switch (menu) {
        case 'START_NOW':
          handleStartNow();
          break;
        case 'START_AFTER':
          handleStartAfter();
          break;
        case 'ADD_TIME':
          handleAddTime();
          break;
        case 'COMPLETE_NOW':
          handleCompleteNow();
          break;
        case 'COMPLETE':
          handleCompleteTaskbox();
          break;
        case 'DELETE':
          handleRemoveTaskbox();
          break;
        case 'TEMPLATE':
          handleCreateTemplate();
          break;
        case 'DUPLICATE':
          handleDuplicateTaskbox();
          break;
        case 'CONVERT_TO_PROJECT':
          handleConvertToProject();
          break;
      }
    } catch (e) {
      toast.error('작업을 수행할 수 없습니다.');
    }
  };

  const handleCompleteTaskbox = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);
    const tasks = contextTaskbox.tasks!.map((v) => ({ ...v, done: !contextTaskbox.done })) as UpdateTaskForTaskBox[];
    const success = await updateTaskboxV1TaskboxesTaskboxIdPut(contextTaskbox!.id!, { ...contextTaskbox, done: !contextTaskbox.done, tasks: tasks });
    if (success) {
      handleChangeTaskBoard(dayjs(currentDate).toDate());
    }
  };

  const handleDuplicateTaskbox = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);
    const newTasks = contextTaskbox.tasks!.map((v) => ({ ...v, id: uuidv4(), categoryId: v.category ? [v.category.id] : [] })) as CreateTaskboxTask[];
    const newTaskbox: CreateTaskbox = {
      ...contextTaskbox,
      id: uuidv4(),
      title: contextTaskbox.title!,
      categoryId: contextTaskbox.category ? [contextTaskbox.category.id] : [],
      tasks: newTasks,
    };
    const success = await createTaskboxV1TaskboxesPost(newTaskbox);
    if (success) {
      handleChangeTaskBoard(dayjs(currentDate).toDate());
      toast.success('태스크박스가 복제되었습니다.');
    }
  };

  const handleRemoveTaskbox = async () => {
    if (!contextTaskbox) return;
    if (contextTaskbox?.isRecurrence) {
      setRemoveRecurringTaskboxPopup(true);
      return;
    }
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);
    await removeTaskboxV1TaskboxesTaskboxIdDelete(contextTaskbox!.id!);
    toast.success('태스크박스를 삭제하였습니다.');
    handleChangeTaskBoard(dayjs(currentDate).toDate());
  };

  const handleRemoveRecurrenceTaskbox = async (params: RemoveTaskboxV1TaskboxesTaskboxIdDeleteParams) => {
    if (!contextTaskbox) return;
    setRemoveRecurringTaskboxPopup(false);
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);
    await removeTaskboxV1TaskboxesTaskboxIdDelete(contextTaskbox.id!, params);
    toast.success('반복 업무를 삭제하였습니다.');
    handleChangeTaskBoard(dayjs(currentDate).toDate(), dayjs(currentDate).add(1, 'week').toDate());
  };

  const handleRemoveRecurrenceEvent = async (params: RemoveEventV1EventsCalendarIdEventIdDeleteParams) => {
    if (!selectedMeeting) return;
    setRemoveRecurringEventPopup(false);
    setMeetingAnchorEl(null);
    setSelectedMeeting(undefined);
    try {
      await removeEventV1EventsCalendarIdEventIdDelete(selectedMeeting.googleCalendarId!, selectedMeeting.id!, params);
      toast.success('반복 일정을 삭제하였습니다.');
      updateMeetings(dayjs(currentDate).toDate());
    } catch (e) {
      toast.error('반복 일정을 삭제할 수 없습니다.');
    }
  };

  const handleCreateTemplate = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);
    const newTemplate: CreateFrequentWork = {
      id: uuidv4(),
      title: contextTaskbox?.title,
      tasks: contextTaskbox!.tasks!.map((item) => ({ ...item, id: uuidv4(), categoryId: item.category ? [item.category.id] : [] })) as CreateFrequentWorkTask[],
    };
    const success = await createFrequentWorkV1FrequentworksPost(newTemplate);
    if (success) {
      fetchIncompleteTaskboxes();
      toast.success('템플릿 목록에 추가되었습니다.');
    }
  };

  const handleConvertToProject = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);

    try {
      await convertTaskToProjectV1ProjectConvertingFromTaskTaskIdPost(contextTaskbox.id!);
      if (projects.filter((project) => project.place === 'DESK').length >= 7) {
        toast.success('데스크가 가득 차서 서랍에 프로젝트를 생성했습니다.');
      } else {
        toast.success('태스크박스를 프로젝트로 전환했습니다.');
      }
    } catch {
      toast.error('프로젝트로 전환하는데 실패하였습니다.');
    }

    handleChangeTaskBoard(dayjs(currentDate).toDate());
  };

  const handleStartNow = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);

    const timeDiff = dayjs(contextTaskbox?.end?.datetime).diff(dayjs(contextTaskbox?.start?.datetime), 'minute');

    try {
      await updateTaskboxV1TaskboxesTaskboxIdPut(contextTaskbox!.id!, {
        start: { datetime: dayjs().format(DATE_FORMAT_1) },
        end: { datetime: !timeDiff ? dayjs().add(1, 'hour').format(DATE_FORMAT_1) : dayjs().add(timeDiff, 'minute').format(DATE_FORMAT_1) },
      });
    } catch (e) {
      toast.error('지금 시작하기를 할 수 없습니다.');
    }
    handleChangeTaskBoard(dayjs(currentDate).toDate());
  };

  const handleStartAfter = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);

    const timeDiff = dayjs(contextTaskbox?.end?.datetime).diff(dayjs(contextTaskbox?.start?.datetime), 'minute');
    const index = taskboxes.findIndex((item) => item.id === contextTaskbox?.id);
    const beforeTaskbox = taskboxes[index - 1];

    try {
      if (beforeTaskbox) {
        await updateTaskboxV1TaskboxesTaskboxIdPut(contextTaskbox!.id!, {
          start: { datetime: dayjs(beforeTaskbox.end?.datetime, { utc: true }).format(DATE_FORMAT_1) },
          end: { datetime: dayjs(beforeTaskbox.end?.datetime, { utc: true }).add(timeDiff, 'minute').format(DATE_FORMAT_1) },
        });
      }
    } catch (e) {
      toast.error('이어서 시작하기를 할 수 없습니다.');
    }
    handleChangeTaskBoard(dayjs(currentDate).toDate());
  };

  const handleAddTime = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);

    try {
      await updateTaskboxV1TaskboxesTaskboxIdPut(contextTaskbox!.id!, {
        start: { datetime: dayjs(contextTaskbox.start?.datetime, { utc: true }).format(DATE_FORMAT_1) },
        end: { datetime: dayjs(contextTaskbox.end?.datetime, { utc: true }).add(30, 'minute').format(DATE_FORMAT_1) },
      });
    } catch (e) {
      toast.error('시간을 추가할 수 없습니다.');
    }
    handleChangeTaskBoard(dayjs(currentDate).toDate());
  };

  const handleCompleteNow = async () => {
    if (!contextTaskbox) return;
    setContextTaskbox(undefined);
    setTaskboxDetailAnchorEl(null);
    const timeDiff = dayjs(contextTaskbox?.end?.datetime).diff(dayjs(contextTaskbox?.start?.datetime), 'minute');

    try {
      await updateTaskboxV1TaskboxesTaskboxIdPut(contextTaskbox!.id!, {
        start: dayjs(contextTaskbox.start?.datetime, { utc: true }).isAfter(dayjs())
          ? { datetime: dayjs().subtract(timeDiff, 'minute').format(DATE_FORMAT_1) }
          : { datetime: dayjs(contextTaskbox.start?.datetime, { utc: true }).format(DATE_FORMAT_1) },
        end: { datetime: dayjs().format(DATE_FORMAT_1) },
        done: true,
      });
    } catch (e) {
      toast.error('지금 완료할 수 없습니다.');
    }
    updateTaskboxes(new Date());
  };

  const handleClickRitual = () => {
    navigate('/ritual');
    setRitualAlarm(false);
    localStorage.setItem('ritual-alarm', 'false');
    setRitualEntry([dayjs().format(DATE_FORMAT_4), true]);
    localStorage.setItem('ritual-entry', JSON.stringify([dayjs().format(DATE_FORMAT_4), true]));
  };

  //TODO : userSetting atom으로 전역 관리

  const handleHighlightNotification = async () => {
    if ((userSetting && !userSetting.isFocusAlarmSet) || shutdownHighlightNotification[1] === true) {
      setHighlightNotification(false);
      localStorage.setItem('highlight-notification', 'false');
      return;
    }

    const currentBoard = taskBoards.find((item) => dayjs(item.date, { utc: true }).isSame(dayjs(), 'date'));
    const currentTaskboxes = currentBoard?.taskboxes.filter((item) => dayjs(item.start?.date || item.start?.datetime, { utc: true }).isSame(dayjs(), 'date'));

    if (currentTaskboxes) {
      const highlightedTaskbox = currentTaskboxes.find((v) => v.focus);
      if (highlightedTaskbox) {
        setShutdownHighlightNotification([dayjs().format(DATE_FORMAT_4), true]);
        localStorage.setItem('shutdown-highlight-notification', JSON.stringify([dayjs().format(DATE_FORMAT_4), true]));
        setHighlightNotification(false);
        localStorage.setItem('highlight-notification', 'false');
        return;
      }
    }

    if (dayjs(currentTaskBoardDate).isToday() && currentTaskboxes && currentTaskboxes.length > 2) {
      setHighlightNotification(true);
      localStorage.setItem('highlight-notification', 'true');
    }
  };

  const handleClickHighlightNotification = () => {
    setShutdownHighlightNotification([dayjs().format(DATE_FORMAT_4), true]);
    localStorage.setItem('shutdown-highlight-notification', JSON.stringify([dayjs().format(DATE_FORMAT_4), true]));
    setOpenHighlightInfo(true);
  };

  const handleClickSnoozeMenu = (time: number) => {
    setSnoozeAnchorEl(null);
    setRitualAlarm(false);
    localStorage.setItem('ritual-alarm', 'false');
    if (time === 0) {
      setRitualEntry([dayjs().format(DATE_FORMAT_4), true]);
      localStorage.setItem('ritual-entry', JSON.stringify([dayjs().format(DATE_FORMAT_4), true]));
    } else {
      setRitualAlarmTime(time);
    }
  };

  const handleBeautifulDndDrop = (date: Date, taskboxes: OutTaskboxDetailResponse[]) => {
    const newTaskboards = taskBoards.map((item) => (item.id === dayjs(date).format(DATE_FORMAT_4) ? { ...item, taskboxes: taskboxes } : item));
    setTaskBoards(newTaskboards);
  };

  const handleCalendarFilter = (filter: CalendarEventsFilter) => {
    if (filter !== null) {
      localStorage.setItem('calendarFilter', filter);
      setCalendarFilter(filter);
    }
  };

  //일정 생성 기능 추가 시 삭제
  const [meetingFilter, setMeetingFilter] = useState<OutFeatureStorage>();

  useEffect(() => {
    fetchCalendarFilter();
  }, []);

  const fetchCalendarFilter = async () => {
    const filter = await getAFeatureStorageByNameV1FeatureStorageNameFeatureStorageNameGet('calendar-filter');
    setMeetingFilter(filter);
  };

  const handleClickMeetingFilter = async () => {
    if (!meetingFilter) return;
    await updateFeatureStorageV1FeatureStorageFeatureStorageIdPatch(meetingFilter.id!, { ...meetingFilter, data: { click: true } });
    setMeetingFilter({ ...meetingFilter, data: { click: true } });
  };

  const handleClickCategoryActions = async (category: OutCategory | null, action: CategoryActionType, eventId?: string) => {
    switch (action) {
      case 'SELECT':
        {
          if (calendarEventEditing) setCalendarEventEditing(false);
          if (newTaskbox && newTaskbox.id === eventId) {
            setNewTaskbox({ ...newTaskbox, categoryId: category ? [category.id] : [] });
          } else {
            const taskbox = taskboxes.find((item) => item.id === eventId);
            if (!taskbox) return;
            await updateTaskboxV1TaskboxesTaskboxIdPut(taskbox.id!, {
              ...pick(taskbox, ['lockedIn', 'start', 'end', 'title']),
              tasks: taskbox.tasks as UpdateTaskForTaskBox[],
              categoryId: category ? [category.id] : [],
            });
            updateTaskboxes(currentDate);
            if (dayjs(currentDate).format(DATE_FORMAT_4) < dayjs().format(DATE_FORMAT_4)) fetchIncompleteTaskboxes();
            taskbox.project ? toast.success('인스턴스를 수정하였습니다.') : toast.success('태스크박스를 수정하였습니다.');
          }
        }
        break;
      case 'CREATE':
        {
          if (!category) return;
          const success = await createCategoryV1CategoryPost(category);
          if (success) {
            fetchCategoryList();
          }
        }
        break;
      case 'UPDATE':
        {
          if (!category) return;
          const success = await updateCategoryV1CategoryCategoryIdPatch(category.id!, category);
          if (success) {
            fetchCategoryList();
          }
        }
        break;
      case 'DELETE':
        {
          if (!category) return;
          await deleteCategoryV1CategoryCategoryIdDelete(category.id!);
          fetchCategoryList();
        }
        break;
    }
  };

  const [openInviteDialog, setOpenInviteDialog] = useState(false);
  const handleChangeInviteDialog = async () => {
    setOpenInviteDialog(false);
  };

  const handleCloseMeetingPopover = async () => {
    if (newMeeting) {
      const endDate = newMeeting?.end?.date ? dayjs(newMeeting.end.date, { utc: true }).subtract(1, 'day') : dayjs(newMeeting?.end?.datetime, { utc: true });
      const isBefore = endDate.isBefore(dayjs(), 'date');
      if (newMeeting.summary !== '' && !newMeeting.isInvited && newMeeting.attendees && newMeeting.attendees?.length > 0 && !openInviteDialog && !isBefore) {
        setOpenInviteDialog(true);
        return;
      }

      setMeetingAnchorEl(null);
      if (newMeeting.summary === '') {
        setNewMeeting(undefined);
        return;
      }
      try {
        setNewMeeting(undefined);
        await createEventV1EventsPost(newMeeting);
        updateMeetings(currentDate);
        toast.success('새로운 일정을 생성하였습니다.');
      } catch (error) {
        setNewMeeting(undefined);
        toast.error('새로운 일정을 생성하는데 실패하였습니다.');
      } finally {
        setOpenInviteDialog(false);
      }
      return;
    }

    if (selectedMeeting) {
      if (selectedMeeting.recurringEventId && selectedMeeting.isUpdated) {
        setUpdateRecurringEventParams({
          ...selectedMeeting,
        });
        return;
      }

      const endDate = selectedMeeting?.end?.date
        ? dayjs(selectedMeeting.end.date, { utc: true }).subtract(1, 'day')
        : dayjs(selectedMeeting?.end?.datetime, { utc: true });
      const isBefore = endDate.isBefore(dayjs(), 'date');
      if (
        selectedMeeting.summary !== '' &&
        !selectedMeeting.isInvited &&
        !openInviteDialog &&
        selectedMeeting.isUpdated &&
        selectedMeeting.attendees &&
        selectedMeeting.attendees?.length > 0 &&
        !isBefore
      ) {
        setOpenInviteDialog(true);
        return;
      }

      setMeetingAnchorEl(null);
      if (selectedMeeting.summary === '') return;
      if (!selectedMeeting.isUpdated) {
        setSelectedMeeting(undefined);
        return;
      }

      const start = selectedMeeting.allDay
        ? { date: dayjs(selectedMeeting.start?.date, { utc: true }).format(DATE_FORMAT_4) }
        : { datetime: dayjs(selectedMeeting.start?.datetime, { utc: true }).format(DATE_FORMAT_1) };
      const end = selectedMeeting.allDay
        ? { date: dayjs(selectedMeeting.end?.date, { utc: true }).format(DATE_FORMAT_4) }
        : { datetime: dayjs(selectedMeeting.end?.datetime, { utc: true }).format(DATE_FORMAT_1) };
      try {
        if (!originGoogleCalendarId) return;
        setSelectedMeeting(undefined);

        const { googleCalendarId, ...others } = selectedMeeting;
        const updatePayload = {
          ...(originGoogleCalendarId !== googleCalendarId ? selectedMeeting : others),
          start,
          end,
        } as UpdateEventWithParam;

        await updateEventsV1EventsCalendarIdEventIdPut(originGoogleCalendarId, selectedMeeting.id, updatePayload);
        updateMeetings(currentDate);
        setOriginGoogleCalendarId(null);
      } catch (error) {
        setSelectedMeeting(undefined);
        toast.error('일정을 수정하는데 실패하였습니다.');
      } finally {
        setOpenInviteDialog(false);
      }
    }
  };

  const handleChangeMeeting = async (
    meeting: CreateEventWithParam & { allDay: boolean; category?: OutCategory | null; isInvited?: boolean; isUpdated?: boolean },
  ) => {
    if (meeting && newMeeting) {
      if (!dayjs(meeting.start?.date || meeting.start.datetime).isSame(dayjs(newMeeting.start?.date || newMeeting.start?.datetime), 'date')) {
        setMeetingAnchorEl(null);
        await handleChangeCurrentDate(dayjs(meeting.start?.date || meeting.start.datetime).toDate());
        setTimeout(() => {
          setNewMeeting({
            ...meeting,
            id: newMeeting.id,
            allDay: meeting.allDay,
          });
        }, 1000);

        setTimeout(() => {
          const el = document.querySelector(`[data-calendar-id="${newMeeting.id}"]`) as HTMLElement;
          setMeetingAnchorEl(el);
        }, 1100);
        return;
      }

      setNewMeeting({
        ...meeting,
        id: newMeeting.id,
        allDay: meeting.allDay,
      });

      if (meeting.allDay !== newMeeting.allDay) {
        setMeetingAnchorEl(null);
        setTimeout(() => {
          const el = document.querySelector(`[data-calendar-id="${newMeeting.id}"]`) as HTMLElement;
          setMeetingAnchorEl(el);
        }, 100);
      }
      return;
    }

    if (meeting && selectedMeeting) {
      if (!dayjs(meeting.start?.date || meeting.start.datetime).isSame(dayjs(selectedMeeting.start?.date || selectedMeeting.start?.datetime), 'date')) {
        setMeetingAnchorEl(null);
        await handleChangeCurrentDate(dayjs(meeting.start?.date || meeting.start.datetime).toDate());

        setTimeout(() => {
          setSelectedMeeting({
            ...(meeting as OutReadEvent),
          });

          const targetMeeting = meetings.find((item) => item.id === selectedMeeting.id);
          if (targetMeeting) {
            const index = meetings.indexOf(targetMeeting);
            const updatedMeetings = [...meetings];
            updatedMeetings[index] = {
              ...(meeting as OutReadEvent),
            };
            setMeetings(updatedMeetings);
          }

          const el = document.querySelector(`[data-calendar-id="${selectedMeeting.id}"]`) as HTMLElement;
          setMeetingAnchorEl(el);
        }, 1000);

        setTimeout(() => {
          const el = document.querySelector(`[data-calendar-id="${selectedMeeting.id}"]`) as HTMLElement;
          setMeetingAnchorEl(el);
        }, 1100);
        return;
      }

      setSelectedMeeting({
        ...(meeting as OutReadEvent),
      });

      const targetMeeting = meetings.find((item) => item.id === selectedMeeting.id);
      if (targetMeeting) {
        const index = meetings.indexOf(targetMeeting);
        const updatedMeetings = [...meetings];
        updatedMeetings[index] = {
          ...(meeting as OutReadEvent),
        };
        setMeetings(updatedMeetings);
      }

      if (meeting.allDay !== selectedMeeting.allDay) {
        setMeetingAnchorEl(null);
        setTimeout(() => {
          const el = document.querySelector(`[data-calendar-id="${selectedMeeting.id}"]`) as HTMLElement;
          setMeetingAnchorEl(el);
        }, 100);
      }

      return;
    }
  };

  const handleDeleteMeeting = async () => {
    if (newMeeting) {
      setMeetingAnchorEl(null);
      setNewMeeting(undefined);
      return;
    }

    if (selectedMeeting) {
      if (selectedMeeting.recurringEventId) {
        setRemoveRecurringEventPopup(true);
        return;
      } else {
        try {
          await removeEventV1EventsCalendarIdEventIdDelete(selectedMeeting.googleCalendarId!, selectedMeeting.id!);
          toast.success('일정을 삭제하였습니다.');
          setMeetingAnchorEl(null);
          setSelectedMeeting(undefined);
          updateMeetings(currentDate);
        } catch (error) {
          toast.error('일정을 삭제하는데 실패하였습니다.');
        }
      }
    }
  };

  const contextMenus = (() => {
    if (!contextTaskbox?.project && contextTaskbox?.allDay && !contextTaskbox?.isRecurrence) {
      return ['START_NOW', 'COMPLETE', 'DELETE', 'TEMPLATE', 'DUPLICATE', 'PROJECT'];
    }

    if (!contextTaskbox?.project && !contextTaskbox?.allDay && !contextTaskbox?.done && contextTaskbox?.isRecurrence) {
      if (isStartAfter) {
        return ['START_NOW', 'START_AFTER', 'ADD_TIME', 'COMPLETE_NOW', 'COMPLETE', 'DELETE', 'TEMPLATE', 'DUPLICATE'];
      } else {
        return ['START_NOW', 'ADD_TIME', 'COMPLETE_NOW', 'COMPLETE', 'DELETE', 'TEMPLATE', 'DUPLICATE'];
      }
    }

    if (!contextTaskbox?.project && !contextTaskbox?.allDay && !contextTaskbox?.done) {
      if (isStartAfter) {
        return ['START_NOW', 'START_AFTER', 'ADD_TIME', 'COMPLETE_NOW', 'COMPLETE', 'DELETE', 'TEMPLATE', 'DUPLICATE', 'PROJECT'];
      } else {
        return ['START_NOW', 'ADD_TIME', 'COMPLETE_NOW', 'COMPLETE', 'DELETE', 'TEMPLATE', 'DUPLICATE', 'PROJECT'];
      }
    }

    if (contextTaskbox?.project && !contextTaskbox?.allDay && !contextTaskbox?.done) {
      if (isStartAfter) {
        return ['START_NOW', 'START_AFTER', 'ADD_TIME', 'COMPLETE_NOW', 'COMPLETE', 'DELETE'];
      } else {
        return ['START_NOW', 'ADD_TIME', 'COMPLETE_NOW', 'COMPLETE', 'DELETE'];
      }
    }

    if (contextTaskbox?.project && contextTaskbox?.allDay && !contextTaskbox?.done) {
      return ['START_NOW', 'COMPLETE', 'DELETE'];
    }

    if (contextTaskbox?.project && contextTaskbox?.allDay && contextTaskbox?.done) {
      return ['COMPLETE', 'DELETE'];
    }

    return ['START_NOW', 'COMPLETE', 'DELETE', 'TEMPLATE', 'DUPLICATE'];
  })();

  const [record, setRecord] = useState<OutRecord>({
    date: dayjs().format('YYYY-MM-DD'),
    id: '',
    status: 'ACTIVE',
    createdAt: '',
    updatedAt: '',
    comboHit: 0,
    content: {},
  });

  useEffect(() => {
    setIsReflectionDialogOpen(localStorage.getItem('reflection-dialog') === 'true');
  }, [localStorage.getItem('reflection-dialog')]);

  useEffect(() => {
    const fetchRecords = async () => {
      const recordDatas = await getAllRecordV1RecordGet({
        startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('month').format('YYYY-MM-DD'),
      });

      if (recordDatas) {
        const filterderRecords = records.filter((record) => !dayjs(record.date).startOf('month').isSame(dayjs().startOf('month')));
        const sortedRecords = [...filterderRecords, ...recordDatas].sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix());
        setRecords(sortedRecords);
      }
    };

    fetchRecords();
  }, []);

  useEffect(() => {
    countDown > 0 && setTimeout(() => setCountDown(countDown - 1), 1000);
    if (countDown <= 0) {
      setIsCompleteCreateDialogOpen(false);
    }
  }, [countDown]);

  const handleChangeRecord = (record: OutRecord) => {
    setRecord(record);
  };

  const handleCreateRecord = async () => {
    if (!record) return;
    const inCreateRecord: InCreateRecord = {
      content: record.content,
      date: record.date,
    };
    const newRecord = await createRecordV1RecordPost(inCreateRecord);
    setRecords([...records, newRecord]);
    setCountDown(3);
    setIsCompleteCreateDialogOpen(true);
    setIsReflectionDialogOpen(false);
    localStorage.setItem('reflection-data', JSON.stringify(true));
    localStorage.removeItem('reflection-dialog');
  };

  const handleUpdateTaskboardFromListView = (date: string, taskboxes: OutTaskboxDetailResponse[]) => {
    const multiDayTaskboxes = taskboxes.filter((item) => item.type === 'TERM_TASK');
    const allDayTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && item.allDay);
    const timeTaskboxes = taskboxes.filter((item) => item.type !== 'TERM_TASK' && !item.allDay);
    const updateTaskboxes = userState.data.taskViewMode === 'SPLIT' ? [...multiDayTaskboxes, ...allDayTaskboxes, ...timeTaskboxes] : taskboxes;
    const newTaskboards = taskBoards.map((item) => (dayjs(item.id).isSame(date) ? { ...item, taskboxes: updateTaskboxes } : item));
    setTaskBoards(newTaskboards);
  };

  useEffect(() => {
    if (syncInstance?.syncType !== 'project') return;

    setTaskBoards((prev) =>
      prev.map((board) => {
        const updatedTaskboxes = board.taskboxes.map((taskbox) => (taskbox.id === syncInstance.id ? { ...taskbox, tasks: syncInstance.tasks } : taskbox));
        return board.taskboxes.some((taskbox) => taskbox.id === syncInstance.id) ? { ...board, taskboxes: updatedTaskboxes } : board;
      }),
    );
  }, [syncInstance]);

  const handleChangeMultiSelectSubtask = (multiSubtaskList: MultiSelectSubtaskIds[], e?: React.MouseEvent<HTMLDivElement>) => {
    setMultiSelectSubtaskIds(multiSubtaskList);

    if (e && (e.ctrlKey || e.metaKey)) {
      setMultiSelectSubtaskAnchorEl(e.currentTarget);
    }

    // else {
    //   setTimeout(() => {
    //     setMultiSelectSubtaskAnchorEl(e.currentTarget);
    //   }, 100);
    // }
  };

  const handleCloseMultiSelectSubtask = () => {
    setMultiSelectSubtaskAnchorEl(null);
    setMultiSelectSubtaskIds([]);
  };

  const handleMultiSelectSubtaskAnchorEl = () => {
    setMultiSelectSubtaskAnchorEl(null);
  };

  const handleClickMultiSelectSubtaskAction = (type: InboxContextMenuType, data: any) => {
    switch (type) {
      case 'MOVE_TO_AFTER':
        handleMoveToAfterMultiSelectSubtask();
        break;
      case 'DELETE':
        handleDeleteMultiSelectSubtask(data);
        break;
      case 'CONVERT_TO_TASKBOX':
        handleConvertToTaskboxMultiSubtask();
        break;
    }
  };

  const handleMoveToAfterMultiSelectSubtask = async () => {
    const taskbox = taskBoards.flatMap((item) => item.taskboxes).find((item) => item.id === multiSelectSubtaskIds[0].taskboxId);
    if (!taskbox) return;
    if (taskbox.project) {
      const targetProject = projects.find((project) => project.id === taskbox.project?.id);
      if (!targetProject) return;

      const instances = targetProject.tasks.filter((task) => task.type !== 'PROJ_SOMEDAY_TASK');
      const index = instances.findIndex((instance) => instance.id === taskbox.id);
      const nextInstance = instances[index + 1];

      try {
        if (nextInstance) {
          const nextInstanceTasks = nextInstance.tasks;
          await assignTasksV1TaskboxesTaskboxIdAssignPost(nextInstance.id!, {
            beforeId: nextInstanceTasks && nextInstanceTasks.length > 0 ? nextInstanceTasks[nextInstanceTasks.length - 1].id : null,
            tasks: multiSelectSubtaskIds[0].subtaskIds,
          });
          toast.success('프로젝트의 다음 인스턴스로 이동했습니다.');
        } else {
          await assignTasksToProjectV1ProjectProjectIdAssigningTaskPost(targetProject.id!, {
            taskIds: multiSelectSubtaskIds[0].subtaskIds,
          });
          toast.success('프로젝트의 미할당으로 이동했습니다.');
        }

        setMultiSelectSubtaskIds([]);
        setMultiSelectSubtaskAnchorEl(null);
        fetchProjects();
        handleChangeTaskBoard(dayjs(taskbox.start?.date || taskbox.start?.datetime, { utc: true }).toDate());
      } catch (error) {
        toast.error('일부 완료에 실패했습니다.');
      }
    } else {
      try {
        const create = await createTaskboxV1TaskboxesPost({
          id: uuidv4(),
          title: taskbox?.title,
          categoryId: taskbox.category && [taskbox?.category?.id],
          deadline: taskbox?.deadline,
        } as CreateTaskbox);

        if (create) {
          await assignTasksV1TaskboxesTaskboxIdAssignPost(create.id!, {
            tasks: multiSelectSubtaskIds[0].subtaskIds,
          });
        }

        setMultiSelectSubtaskIds([]);
        setMultiSelectSubtaskAnchorEl(null);
        handleChangeTaskBoard(dayjs(taskbox.start?.date || taskbox.start?.datetime, { utc: true }).toDate());
        updateTodoTasks();
      } catch (e) {
        toast.error('나중에로 보낼 수 없습니다.');
      }
    }
  };

  const handleDeleteMultiSelectSubtask = async (data: any) => {
    const taskbox = taskBoards.flatMap((item) => item.taskboxes).find((item) => item.id === multiSelectSubtaskIds[0].taskboxId);
    if (!taskbox) return;
    try {
      await updateTaskboxV1TaskboxesTaskboxIdPut(taskbox.id!, {
        ...taskbox,
        tasks: taskbox?.tasks?.filter((task) => !data.includes(task.id!)) as UpdateTaskForTaskBox[],
      });
      setMultiSelectSubtaskIds([]);
      setMultiSelectSubtaskAnchorEl(null);
      handleChangeTaskBoard(dayjs(taskbox.start?.date || taskbox.start?.datetime, { utc: true }).toDate());
      updateTodoTasks();
    } catch (e) {
      toast.error('삭제할 수 없습니다.');
    }
  };

  const handleConvertToTaskboxMultiSubtask = async () => {
    const taskbox = taskBoards.flatMap((item) => item.taskboxes).find((item) => item.id === multiSelectSubtaskIds[0].taskboxId);
    if (!taskbox) return;

    try {
      const create = await createTaskboxV1TaskboxesPost({
        id: uuidv4(),
        title: taskbox?.title,
        // categoryId: [taskbox?.category?.id],
        // deadline: taskbox?.deadline,
        start: {
          date: dayjs(taskbox?.start?.date || taskbox?.start?.datetime).format(DATE_FORMAT_4),
        },
        end: {
          date: dayjs(taskbox?.end?.date || taskbox?.end?.datetime).format(DATE_FORMAT_4),
        },
      } as CreateTaskbox);

      if (create) {
        await assignTasksV1TaskboxesTaskboxIdAssignPost(create.id!, {
          tasks: multiSelectSubtaskIds[0].subtaskIds,
        });
      }

      setMultiSelectSubtaskIds([]);
      setMultiSelectSubtaskAnchorEl(null);
      handleChangeTaskBoard(dayjs(currentDate).toDate());
      updateTodoTasks();
    } catch (e) {
      toast.error('태스크박스로 전환할 수 없습니다.');
    }
  };

  // const handleChangeMultiSelectList = (id: string[]) => {
  //   const lastId = id[id.length - 1];
  //   const anchorEl = document.querySelector(`[data-taskbox="${lastId}"]`) as HTMLElement;
  //   setSelectedEventId(undefined);
  //   setTimeout(() => {
  //     setMultiSelectAnchorEl(anchorEl);
  //     setMultiSelectTaskboxIds([...id]);
  //   }, 100);
  // };

  return (
    <Container>
      {!foldCalendar && (
        <>
          <CalendarView
            refCalendarView={refCalendarView}
            newEventId={newTaskbox?.id}
            events={
              calendarFilter === 'MEETING'
                ? calendarEvents.filter((v) => v.type === 'meeting')
                : calendarFilter === 'TASK'
                ? calendarEvents.filter((v) => v.type === 'task')
                : calendarEvents
            }
            selectedEventId={selectedEventId}
            currentDate={currentDate}
            calendarFilter={calendarFilter}
            meetingFilter={meetingFilter}
            onClickRefresh={handleRefresh}
            onClickToggleView={() => navigate('/task/week')}
            onClickCalendarFilter={handleCalendarFilter}
            onSelectEvent={handleSelectEvent}
            onUpdateEvent={handleUpdateEvent}
            onUpdateEventTitle={handleUpdateEventTitle}
            onChangeEventEditing={handleChangeEventEditing}
            onClickTimeSlot={handleClickTimeSlot}
            onChangeCurrentDate={handleChangeCurrentDate}
            onDropFromOutside={handleDropFromOutside}
            onClickFoldCalendarView={handleClickFoldCalendarView}
            onContextMenuEvent={handleEventContextMenu}
            onClickMeetingFilter={handleClickMeetingFilter}
            onClickCategoryActions={handleClickCategoryActions}
          />

          {isLoading && (
            <div style={{ position: 'absolute', top: `calc(100vh - 50%)`, left: '220px' }}>
              <CircularProgress size={32} sx={{ color: COLORS.brand1 }} />
            </div>
          )}
        </>
      )}
      {foldCalendar &&
        createPortal(
          <Tooltip
            title={
              <div style={{ padding: '5px 8px' }}>
                <span>왼쪽 탭 접기/펼치기</span>
                <KeyboardButtonRect style={{ marginLeft: 8 }}> {osName === 'Windows' ? 'Ctrl' : '⌘'}</KeyboardButtonRect>
                <KeyboardCommandPlus>+</KeyboardCommandPlus>
                <KeyboardButtonRect>{osName === 'Windows' ? 'Alt' : 'Option'}</KeyboardButtonRect>
                <KeyboardCommandPlus>+</KeyboardCommandPlus>
                <KeyboardButtonRect>{`[`}</KeyboardButtonRect>
              </div>
            }
            placement="right"
            disableInteractive
            sx={{ padding: '0px' }}
          >
            <IconButton
              onClick={handleClickFoldCalendarView}
              sx={{
                'width': '32px',
                'height': '32px',
                'position': 'absolute',
                'left': 64,
                'top': 114,
                'zIndex': 10,
                'backgroundColor': COLORS.white,
                'borderRadius': '8px',
                'border': `1px solid ${COLORS.gray300}`,
                'boxShadow': `0px 8px 16px 0px rgba(26, 30, 39, 0.16)`,
                'padding': '4px',
                ':hover': {
                  backgroundColor: COLORS.sub3,
                },
              }}
            >
              <Icons.ArrowRightSmall fill={COLORS.gray900} />
            </IconButton>
          </Tooltip>,
          document.body,
        )}
      <TaskViewWrapper ref={refTaskView} id="task-view" foldCalendar={foldCalendar} foldSidePanel={foldSidePanel}>
        <TaskViewFixedCenter>
          <TaskBoardWrapper style={{ visibility: isLoading && !isFirstLoading ? 'hidden' : 'visible' }}>
            {taskBoards.length ? (
              <TaskBoardTopButtonWrapper>
                <Button
                  disableElevation
                  color="inherit"
                  variant="text"
                  sx={{ margin: 0, minWidth: 160 }}
                  onClick={handleClickBeforeDate}
                  style={{ overflowAnchor: 'none' }}
                >
                  {isLoading ? (
                    <CircularProgress color="inherit" size={20} style={{ color: COLORS.gray500 }} />
                  ) : (
                    <>
                      <TaskBoardButtonTextWrapper>지난날 업무 일지 보기</TaskBoardButtonTextWrapper>
                      <Icons.ArrowUpSmall fill={COLORS.gray600} />
                    </>
                  )}
                </Button>
              </TaskBoardTopButtonWrapper>
            ) : (
              <></>
            )}
            {taskBoards?.map((v) => (
              <TaskBoard
                key={v.id}
                id={v.id}
                date={v.date}
                taskboxes={v.taskboxes}
                entireBoardTaskboxes={taskBoards.flatMap((item) => item.taskboxes)}
                focused={dayjs(v.date).isSame(currentDate, 'day')}
                editing={boardWritingStatus.get(dayjs(v.date).format(DATE_FORMAT_4))}
                expanded={boardExpandStatus.get(dayjs(v.date).format(DATE_FORMAT_4))}
                parentRef={refTaskView}
                selectedEventId={selectedEventId}
                selectedSubtaskId={selectedSubtaskId}
                incompleteTaskboxList={incompleteTaskboxList}
                templateList={templateList}
                multiSelectIds={multiSelectTaskboxIds}
                multiSelectAnchorEl={multiSelectAnchorEl}
                categoryList={categoryList}
                multiSelectSubtaskIds={multiSelectSubtaskIds}
                multiSelectSubtaskAnchorEl={multiSelectSubtaskAnchorEl}
                onChange={handleChangeTaskBoard}
                onCreateTaskbox={handleAddTaskbox}
                onClickEditTaskBoard={handleClickCreateTaskBoard}
                onClickExpand={handleClickExpand}
                onClickTaskbox={handleClickTaskbox}
                onClickSubtask={handleClickSubtask}
                onClickTaskBoard={handleClickTaskBoard}
                onDropTask={handleDropTaskOnTaskBoard}
                onFetchIncompleteTaskboxes={fetchIncompleteTaskboxes}
                onFetchTemplateList={fetchTemplateList}
                onChangeMultiSelectIds={handleChangeMultiSelect}
                onChangeMultiSelectList={handleChangeMultiSelectList}
                onCloseMultiSelect={handleCloseMultiSelect}
                onMultiSelectAnchorElNull={handleMultiSelectAnchorElNull}
                onChangeTimer={onChangeTimer}
                onBeautifulDndDrop={handleBeautifulDndDrop}
                onFetchCategoryList={fetchCategoryList}
                onUpdateTaskboardFromListView={handleUpdateTaskboardFromListView}
                onContextMenuTaskbox={handleTaskboxContextMenu}
                onChangeMultiSelectSubtaskIds={handleChangeMultiSelectSubtask}
                onClickMultiSelectSubtaskAction={handleClickMultiSelectSubtaskAction}
                onCloseMultiSelectSubtask={handleCloseMultiSelectSubtask}
                onMultiSelectSubtaskAnchorElNull={handleMultiSelectSubtaskAnchorEl}
              />
            ))}
            {taskBoards.length ? (
              <TaskBoardBottomButtonWrapper ref={refInBottomView}>
                {isLoading ? <CircularProgress color="inherit" size={20} style={{ color: COLORS.gray500 }} /> : <></>}
              </TaskBoardBottomButtonWrapper>
            ) : (
              <></>
            )}
          </TaskBoardWrapper>
        </TaskViewFixedCenter>
        {!dayjs(currentTaskBoardDate).isToday() && (
          <Tooltip
            title={
              <div style={{ margin: '2px 4px' }}>
                <span>오늘로 이동</span>
                <KeyboardButtonRect small style={{ marginLeft: 8 }}>
                  Shift
                </KeyboardButtonRect>
                <KeyboardCommandPlus>+</KeyboardCommandPlus>
                <KeyboardButtonRect small>T</KeyboardButtonRect>
              </div>
            }
            disableInteractive
          >
            <Button
              sx={{
                'width': '104px',
                'height': '36px',
                'position': 'absolute',
                'bottom': 27,
                'zIndex': 101,
                'fontSize': 13,
                'fontWeight': 700,
                'backgroundColor': COLORS.white,
                'borderRadius': '50px',
                'border': `1px solid ${COLORS.gray200}`,
                'boxShadow': '0px 8px 16px 0px rgba(26, 30, 39, 0.16)',
                ':hover': {
                  backgroundColor: COLORS.sub3,
                  border: `1px solid ${COLORS.gray300}`,
                },
              }}
              onClick={() => handleChangeCurrentDate(new Date())}
            >
              오늘로 이동하기
            </Button>
          </Tooltip>
        )}
        {dayjs(currentTaskBoardDate).isToday() && highlightNotification && (
          <LightTooltip disableInteractive title={'💡 가장 중요한 일을 하이라이트하면 사라져요!'} sx={{ color: COLORS.gray900 }}>
            <Button
              startIcon={
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                  <path
                    d="M8.5 14.2C7.67 14.2 6.89 14.0424 6.16 13.7272C5.43 13.4124 4.795 12.985 4.255 12.445C3.715 11.905 3.2876 11.27 2.9728 10.54C2.6576 9.81 2.5 9.03 2.5 8.2C2.5 7.06 2.7976 6.0074 3.3928 5.0422C3.9876 4.0774 4.795 3.34 5.815 2.83C5.825 3.02 5.845 3.2124 5.875 3.4072C5.905 3.6024 5.955 3.83 6.025 4.09C5.305 4.53 4.7374 5.1124 4.3222 5.8372C3.9074 6.5624 3.7 7.35 3.7 8.2C3.7 9.54 4.165 10.675 5.095 11.605C6.025 12.535 7.16 13 8.5 13C9.84 13 10.975 12.535 11.905 11.605C12.835 10.675 13.3 9.54 13.3 8.2C13.3 7.35 13.0924 6.56 12.6772 5.83C12.2624 5.1 11.69 4.515 10.96 4.075C11.03 3.815 11.08 3.5874 11.11 3.3922C11.14 3.1974 11.165 3.01 11.185 2.83C12.205 3.34 13.0126 4.075 13.6078 5.035C14.2026 5.995 14.5 7.05 14.5 8.2C14.5 9.03 14.3424 9.81 14.0272 10.54C13.7124 11.27 13.285 11.905 12.745 12.445C12.205 12.985 11.57 13.4124 10.84 13.7272C10.11 14.0424 9.33 14.2 8.5 14.2ZM8.5 11.8C7.5 11.8 6.65 11.45 5.95 10.75C5.25 10.05 4.9 9.2 4.9 8.2C4.9 7.62 5.0276 7.075 5.2828 6.565C5.5376 6.055 5.9 5.63 6.37 5.29C6.42 5.44 6.475 5.6124 6.535 5.8072C6.595 6.0024 6.675 6.245 6.775 6.535C6.555 6.765 6.3876 7.02 6.2728 7.3C6.1576 7.58 6.1 7.88 6.1 8.2C6.1 8.86 6.335 9.425 6.805 9.895C7.275 10.365 7.84 10.6 8.5 10.6C9.16 10.6 9.725 10.365 10.195 9.895C10.665 9.425 10.9 8.86 10.9 8.2C10.9 7.88 10.8426 7.58 10.7278 7.3C10.6126 7.02 10.445 6.765 10.225 6.535C10.305 6.295 10.3776 6.0724 10.4428 5.8672C10.5076 5.6624 10.565 5.47 10.615 5.29C11.085 5.63 11.45 6.055 11.71 6.565C11.97 7.075 12.1 7.62 12.1 8.2C12.1 9.2 11.75 10.05 11.05 10.75C10.35 11.45 9.5 11.8 8.5 11.8ZM8.5 1C8.92 1 9.275 1.145 9.565 1.435C9.855 1.725 10 2.08 10 2.5C10 2.83 9.9576 3.1924 9.8728 3.5872C9.7876 3.9824 9.6 4.615 9.31 5.485C9.25 5.665 9.1476 5.8126 9.0028 5.9278C8.8576 6.0426 8.69 6.1 8.5 6.1C8.31 6.1 8.1426 6.0426 7.9978 5.9278C7.8526 5.8126 7.75 5.665 7.69 5.485C7.4 4.615 7.2126 3.9824 7.1278 3.5872C7.0426 3.1924 7 2.83 7 2.5C7 2.08 7.145 1.725 7.435 1.435C7.725 1.145 8.08 1 8.5 1ZM8.5 9.4C8.17 9.4 7.8876 9.2824 7.6528 9.0472C7.4176 8.8124 7.3 8.53 7.3 8.2C7.3 7.87 7.4176 7.5874 7.6528 7.3522C7.8876 7.1174 8.17 7 8.5 7C8.83 7 9.1126 7.1174 9.3478 7.3522C9.5826 7.5874 9.7 7.87 9.7 8.2C9.7 8.53 9.5826 8.8124 9.3478 9.0472C9.1126 9.2824 8.83 9.4 8.5 9.4Z"
                    fill="white"
                  />
                </svg>
              }
              sx={{
                'width': '224px',
                'height': '40px',
                'position': 'absolute',
                'bottom': 27,
                'zIndex': 101,
                'fontSize': 13,
                'fontWeight': 700,
                'background': 'var(--Gradation, linear-gradient(180deg, #C471ED 1.78%, #F64F59 97.94%))',
                'borderRadius': '50px',
                'border': `1px solid ${COLORS.gray200}`,
                'boxShadow': '0px 8px 16px 0px rgba(26, 30, 39, 0.16)',
                'color': COLORS.white,
                ':hover': {
                  backgroundColor: COLORS.sub3,
                  border: `1px solid ${COLORS.gray300}`,
                },
              }}
              onClick={handleClickHighlightNotification}
            >
              오늘 가장 중요한 일은 무엇인가요?
            </Button>
          </LightTooltip>
        )}
      </TaskViewWrapper>
      {taskSelectionModal && taskSelectionModal.open && (
        <Dialog open={taskSelectionModal.open} sx={{ borderRadius: 8 }}>
          <TaskSelectionView
            issueTitle={taskSelectionModal.issueTitle}
            tasks={taskSelectionModal.tasks}
            closeIcon
            onClickCancel={() => setTaskSelectionModal(null)}
            onClickComplete={handleClickTaskSelection}
          />
        </Dialog>
      )}
      <div style={{ position: 'relative' }}>
        {ritualAlarm && (
          <RitualNotification>
            <Icons.OrganizeToday />
            <div>
              <div style={{ fontSize: 12, fontWeight: 700 }}>오늘 정리하기</div>
              <div style={{ color: COLORS.gray500, fontSize: 10, fontWeight: 700 }}>오늘 하루를 정리해보세요</div>
            </div>
            <div>
              <IconButton sx={{ width: 20, height: 20, padding: '2.5px 2px', borderRadius: '6px' }} onClick={(e) => setRitualSettingEl(e.currentTarget)}>
                <Icons.More />
              </IconButton>
              <IconButton sx={{ width: 20, height: 20, padding: '2.5px 2px', borderRadius: '6px' }} onClick={(e) => setSnoozeAnchorEl(e.currentTarget)}>
                <Icons.Close width={14} height={14} />
              </IconButton>
            </div>
          </RitualNotification>
        )}
        <Tooltip title="오늘 정리하기" disableInteractive>
          <IconButton
            onClick={() => {
              handleClickRitual();
              GAEventTrigger({ action: 'ritual_shutdown_init', category: 'ritual_shutdown_init' });
            }}
            sx={{
              'position': 'absolute',
              'bottom': 20,
              'left': -70,
              'zIndex': 101,
              'width': 48,
              'height': 48,
              'backgroundColor': ritualAlarm ? COLORS.brand1 : COLORS.white,
              'boxShadow': '0px 8px 16px 0px rgba(26, 30, 39, 0.16)',
              ':hover': ritualAlarm ? { backgroundColor: COLORS.sub2 } : { backgroundColor: COLORS.white },
            }}
          >
            <Icons.Ritual stroke={ritualAlarm ? COLORS.white : COLORS.brand1} />
          </IconButton>
        </Tooltip>
      </div>
      {tutorialAnchorEl && (
        <TutorialWrapper>
          <Popover
            disablePortal
            open={Boolean(tutorialAnchorEl) && !tutorialStatus}
            anchorEl={tutorialAnchorEl}
            anchorOrigin={
              tutorialAnchorEl?.id === 'tutorial-replay'
                ? {
                    vertical: 'bottom',
                    horizontal: 'right',
                  }
                : {
                    vertical: 'bottom',
                    horizontal: 'left',
                  }
            }
            transformOrigin={
              tutorialAnchorEl?.id === 'tutorial-replay'
                ? {
                    vertical: 'bottom',
                    horizontal: 'left',
                  }
                : { vertical: 'top', horizontal: 'center' }
            }
            style={{ marginTop: '8px' }}
          >
            <div style={tutorialAnchorEl?.id === 'tutorial-replay' ? { display: 'flex' } : { display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <TutorialArrowContainer style={tutorialAnchorEl?.id === 'tutorial-replay' ? { width: '20px', height: '100%' } : {}} />
              <Tutorial
                onClickTutorialButton={handleClickTutorialButton}
                onClickTutorialReplay={handleClickTutorialReplay}
                onCloseTutorial={handleCloseTutorial}
                tutorialStatus={tutorialStatus}
                tutorialEl={tutorialAnchorEl}
              />
            </div>
          </Popover>
          <Modal open={tutorialReplay} onClose={handleCloseTutorialReplay}>
            <Tutorial replay={tutorialReplay} tutorialStatus={tutorialStatus} />
          </Modal>
        </TutorialWrapper>
      )}
      {taskboxDetailAnchorEl && (
        <Popover
          open={Boolean(taskboxDetailAnchorEl)}
          anchorEl={taskboxDetailAnchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          sx={{ marginLeft: 1, zIndex: 102 }}
          onClose={() => {
            setTaskboxDetailAnchorEl(null);
            setContextTaskbox(undefined);
          }}
        >
          <InboxContextMenu
            id={contextTaskbox!.id!}
            type={contextTaskbox?.project ? 'instance' : 'taskbox'}
            done={contextTaskbox?.done}
            menus={contextMenus as InboxContextMenuType[]}
            data={contextTaskbox?.tasks}
            onClickMenu={handleClickContextMenu}
          />
        </Popover>
      )}
      {meetingAnchorEl && (
        <Popover
          open={Boolean(meetingAnchorEl)}
          anchorEl={meetingAnchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          sx={{ marginLeft: 1, zIndex: 102 }}
          onClose={handleCloseMeetingPopover}
        >
          <EventCreationPopover
            event={newMeeting || ({ ...selectedMeeting } as CreateEventWithParam & { allDay: boolean; category: OutCategory })}
            currentDate={currentDate}
            isNewEvent={Boolean(newMeeting)}
            openDialog={openInviteDialog}
            onSave={handleCloseMeetingPopover}
            onChange={handleChangeMeeting}
            onDelete={handleDeleteMeeting}
            onClickCategory={handleClickCategoryActions}
            onChangeDialog={handleChangeInviteDialog}
          />
        </Popover>
      )}
      {ritualSettingEl && (
        <Popover
          open={Boolean(ritualSettingEl)}
          anchorEl={ritualSettingEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          onClose={() => setRitualSettingEl(null)}
        >
          <MenuList sx={{ padding: '12px' }}>
            <MenuItem
              onClick={() => navigate('/settings?section=notification')}
              sx={{
                'borderRadius': '8px',
                'fontSize': 12,
                'padding': '8px',
                ':hover': {
                  backgroundColor: COLORS.gray100,
                },
              }}
            >
              하루 정리하기 설정
            </MenuItem>
          </MenuList>
        </Popover>
      )}
      {snoozeAnchorEl && (
        <Popover
          open={Boolean(snoozeAnchorEl)}
          anchorEl={snoozeAnchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          onClose={() => setSnoozeAnchorEl(null)}
        >
          <SnoozeWrapper>
            <div style={{ fontSize: '13px', fontWeight: 700, padding: '2px 16px' }}>스누즈</div>
            <div style={{ fontSize: '10px', padding: '5px 16px' }}>나중에 알림을 받을 수 있어요</div>
            <MenuList>
              <MenuItem onClick={() => handleClickSnoozeMenu(0.5)}>30분 후</MenuItem>
              <MenuItem onClick={() => handleClickSnoozeMenu(1)}>1시간 후</MenuItem>
              <MenuItem onClick={() => handleClickSnoozeMenu(2)}>2시간 후</MenuItem>
              <MenuItem onClick={() => handleClickSnoozeMenu(0)}>오늘은 알리지 않기</MenuItem>
            </MenuList>
          </SnoozeWrapper>
        </Popover>
      )}
      {(updateRecurringTaskboxParams || updateRecurringEventParams) && (
        <UpdateRecurrenceDialog
          open={Boolean(updateRecurringTaskboxParams || updateRecurringEventParams)}
          type={updateRecurringTaskboxParams ? 'TASK' : 'MEETING'}
          onClose={updateRecurringTaskboxParams ? () => setUpdateRecurringTaskboxParams(null) : () => setUpdateRecurringEventParams(null)}
          onUpdateRecurrence={updateRecurringTaskboxParams ? handleUpdateRecurrenceTask : handleUpdateRecurrenceEvent}
        />
      )}
      {(removeRecurringTaskboxPopup || removeRecurringEventPopup) && (
        <RemoveRecurrenceDialog
          open={removeRecurringTaskboxPopup || removeRecurringEventPopup}
          type={updateRecurringTaskboxParams ? 'TASK' : 'MEETING'}
          onClose={removeRecurringTaskboxPopup ? () => setRemoveRecurringTaskboxPopup(false) : () => setRemoveRecurringEventPopup(false)}
          onRemoveRecurrence={removeRecurringTaskboxPopup ? handleRemoveRecurrenceTaskbox : handleRemoveRecurrenceEvent}
        />
      )}
      <HighlightInfoDialog open={openHighlightInfo} onClose={() => setOpenHighlightInfo(false)} />
      <Dialog
        open={isReflectionDialogOpen}
        onClose={() => {
          if (record.content && (record.content.memo || record.content.keep || record.content.problem || record.content.try)) {
            handleCreateRecord();
          } else {
            setIsReflectionDialogOpen(false);
          }
        }}
        maxWidth="md"
      >
        <div style={{ height: '726px', width: '900px' }}>
          <ReflectionTemplate
            isTaskView
            readOrcreateOrUpdate={'create'}
            padding="0px 0px 0px 20px"
            record={record}
            onChange={handleChangeRecord}
            closeDialog={() => {
              localStorage.removeItem('reflection-dialog');
              setIsReflectionDialogOpen(false);
            }}
            createOrUpdateRecord={handleCreateRecord}
          />
        </div>
      </Dialog>
      <Dialog open={isCompleteCreateDialogOpen} onClose={() => setIsCompleteCreateDialogOpen(false)} maxWidth="md">
        <CompleteCreateWrapper>
          <img src={require('assets/images/completeCreateReflection.png')} style={{ width: '94px', height: '94px' }} />
          <CompleteCreateTitle>회고록 작성 완료!</CompleteCreateTitle>
          <CompleteCreateSubTitle>수고하셨어요! 한 걸음 더 성장했어요.</CompleteCreateSubTitle>
          <ReflectionCalendarReadOnly records={records} recordDate={record.date} />
          <CompleteCreateNotice>{countDown}초 후 자동으로 창이 닫혀요.</CompleteCreateNotice>
        </CompleteCreateWrapper>
      </Dialog>
    </Container>
  );
};

export default TaskToday;

const LightTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLORS.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: 'rgba(26, 30, 39, 0.16) 0px 8px 16px 0px',
    fontSize: 11,
    fontWeight: 700,
    padding: '8px',
    borderRadius: '8px',
  },
}));
